/* eslint-disable prettier */
/**
 * Fr resource file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: 'Tout effacer',
	canvasOversight: 'Surveillance d’EY Canvas',
	oversight: 'Surveillance',
	canvasLabel: 'Canvas',
	myProjects: 'Mes projets',
	otherProjects: 'Autres projets',
	priorProjects: 'Projets précédents',
	completedProjects: 'Projets terminés',
	completedLabel: 'Terminé',
	createProject: 'Créer un projet',
	rollForward: 'Récupérer',
	rollForwardLabel: 'Récupérer',
	rollForwardTitle: 'Récupérer votre projet',
	project: 'Projet',
	openProject: 'Ouvrir le projet',
	manageUsers: 'Gérer les utilisateurs',
	rollForwardInstructionalText: 'Voulez-vous vraiment récupérer votre projet?<br> Cela vous permettra d’utiliser un projet terminé comme gabarit lors de la création d’un nouveau projet. Les informations suivantes seront récupérées : nom du projet, organigramme, groupes et administrateurs du groupe.',
	isClientUserError: 'Vous n’avez aucun projet actif. Veuillez communiquer avec un membre de l’équipe EY pour être invité(e) à un projet.',
	activeProjects: 'Projets actifs',
	myActiveProjects: 'Mes projets actifs',
	otherActiveProjects: 'Autres projets actifs',
	myCompletedProjects: 'Mes projets terminés',
	myActiveProjectsPlaceholder: 'Vous avez accès aux projets Oversight EY Canvas suivants. Sélectionnez le nom d’un projet pour l’ouvrir ou cliquez sur le nombre de projets pour afficher les détails.',
	deleteProject: 'Supprimer le projet',
	deleteProjectModalText: 'Voulez-vous vraiment supprimer ce projet?<br>Le projet sera supprimé de votre page d’accueil et plus aucun membre de l’équipe n’y aura accès.',
	createButton: 'Créer un projet',
	search: 'Rechercher',
	searchEngagement: 'Rechercher une mission',
	searchEngagements: 'Rechercher des missions',
	searchEntitiesAndEngagements: 'Rechercher des entités et des missions',
	searchClientList: 'Rechercher le nom du client',
	noDataFound: 'Aucune donnée à afficher.',
	expand: 'Développer',
	collapse: 'Réduire',
	more: 'Plus',
	options: 'Options',
	editProject: 'Modifier le projet',
	manageTeam: 'Gérer l’équipe',
	markAsCompleted: 'Inscrire comme terminé',
	connectedTo: 'Connectée à',
	connectedClients: 'Clients connectés',
	connectedToClients: (count) => `${count} ${count == 1 ? 'client' : 'clients'}`,
	connectedToEngagements: (count) => `Engagements: ${count == 0 ? 'None' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'engagement' : 'engagements'}`,
	connectToEngagements: (count) => `Connect ${count} ${count == 1 ? 'engagement' : 'engagements'}`,
	connectedToAccessGroups: (count) => `Connected to ${count} ${count == 1 ? 'group' : 'groups'}`,
	connectToAccessGroups: (count) => `Connect ${count} ${count == 1 ? 'group' : 'groups'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entity' : 'Entities'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'View' : 'Views'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domain' : 'Domains'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'View' : 'Views'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domain' : 'Domains'}`,
	engagement: 'mission',
	engagementNameLabel: 'Nom de la mission',
	engagementPartnerLabel: 'Associé responsable de la mission',
	partnerLabel: 'Associé',
	notInvited: 'Non invité',
	clientNameLabel: 'Nom du client',
	client: 'Clients',
	codeLabel: 'Code',
	idLabel: 'Identifiant',
	engagements: 'missions',
	engagementsLabel: 'Missions',
	noResultsFound: 'Aucun résultat trouvé.',
	submit: 'Envoyer',
	saveAndContinue: 'Enregistrer et continuer',
	savecontinue: 'Enregistrer et continuer',
	saveDraft: 'Enregistrer en tant que brouillon',
	closeLabel: 'Fermer',
	step1: 'Étape 1',
	step2: 'Étape 2',
	step3: 'Étape 3',
	step4: 'Étape 4',
	step5: 'Étape 5',
	adminsNoneLabel: 'Aucun',
	domainsAllLabel: 'Tous',
	adminsHeaderLabel: 'Administrateurs :',
	domainsHeaderLabel: 'Domaines :',
	moreCountLabel: '+ {0}',
	selectClient: 'Sélectionner un client',
	createOrgChart: 'Créer un organigramme',
	connnectToCanvas: 'Se connecter à EY Canvas',
	viewSummary: 'Afficher le sommaire',
	viewLabel: 'Afficher',
	cancelLabel: 'Annuler',
	required: 'Requis',
	filter: 'filtre',
	filtersWarningMessage: 'Le nombre maximal de filtres est dépassé. Vous ne pouvez appliquer que 25 filtres à la fois.',
	back: 'Retour',
	save: 'Enregistrer',
	saveClose: 'Enregistrer et fermer',
	continue: 'Continuer',
	finish: 'Terminer',
	saveChanges: 'Enregistrer les modifications',
	projectName: 'Nom du projet',
	projectOwners: 'Propriétaires de projet',
	addAnotherProjectOwner: 'Ajouter un autre propriétaire de projet',
	duplicateOwnerAdded: 'Utilisateur en double',
	step1InstructionHeader: 'Veuillez entrer un nom pour votre projet, ajouter d’autres propriétaires de projet et sélectionner au moins un client à partir de la liste ci-après pour commencer.',
	step1SubInstructionPart1: `Vous devez avoir accès au code client selon le GIS, le GFIS ou Mercury ou à une mission EY Canvas pour voir le nom du client ci-après. Les clients sélectionnés à cette étape détermineront les missions EY Canvas auxquelles vous pouvez connecter votre projet. Pour en apprendre davantage sur l’utilisation du module Surveillance d’EY Canvas, consultez notre {link}.`,
	step2InstructionHeader: 'Créer un organigramme pour votre projet.',
	step2SubInstructionPart1: "L’organigramme doit refléter la manière dont votre client gère ses activités. Il sera utilisé pour synthétiser les données utilisées dans les missions EY Canvas que vous connectez à votre projet, ainsi que pour gérer l’accès des membres de l'équipe internes et externes.",
	here: 'ici',
	zoomIn: 'Effectuer un zoom avant',
	zoomOut: 'Effectuer un zoom arrière',
	expandAll: 'Tout développer',
	collapseAll: 'Tout réduire',
	addLabel: 'Ajouter',
	editLabel: 'Modifier',
	removeLabel: 'Retirer',
	noRowsTemplateStringPart1: 'Vous n’avez accès à aucun client. Cliquez sur',
	noRowsTemplateStringPart2: 'pour en savoir davantage sur la manière d’obtenir l’accès.',
	noRowSelected: 'Sélectionnez au moins un client pour continuer.',
	firstName: 'Prénom',
	lastName: 'Nom de famille',
	displayLanguage: 'Langue d’affichage',
	numberFormat: 'Format numérique',
	dateFormat: 'Format de date',
	timezone: 'Fuseau horaire',
	theme: 'Thème',
	chooseDisplayTheme: 'Choisissez votre thème d’affichage par défaut.',
	light: 'Clair',
	dark: 'Sombre',
	usersettings: 'Paramètres de l’utilisateur',
	userOptions: 'Options de l’utilisateur',
	clearHoverText: 'Effacer',
	noFiltersAvailable: 'Aucun filtre disponible',
	dashboard: 'Tableau de bord',
	milestones: 'Jalons',
	activityFeed: 'Flux d’activité',
	keyEvents: 'Événements clés',
	keyEventCompletion: 'Achèvement de l’événement clé',
	canvasClientPortal: 'Portail client d’EY Canvas',
	canvasClientPortalEy: 'Portail client EY Canvas',
	groupAudit: 'Audit de groupe',
	projectManagement: 'Gestion de projet',
	reporting: 'Rapport',
	insights: 'Informations',
	groupRiskAssessment: 'Évaluation des risques au niveau du groupe',
	internal: 'internes',
	external: 'externes',
	members: 'membres',
	show: 'Afficher',
	showDetails: 'Afficher les détails',
	showMore: 'Afficher plus',
	showLess: 'Afficher moins',
	clientName: 'Nom du client',
	clientsLabel: 'Clients',
	clientLabel: 'Client',
	source: 'Source',
	code: 'Code',
	accessDelegatedBy: 'Droits d’accès attribués par',
	returnToPreviousStep: 'Retourner à l’étape précédente',
	backButtonWarning: 'Le fait de retourner à une étape précédente et d’y apporter des modifications pourrait avoir une incidence sur la progression de l’étape en cours.<br> Sélectionnez <b>Continuer</b> pour revenir à une étape précédente ou <b>Annuler</b> pour continuer avec l’étape en cours.',
	step1SubInstructionPart3: 'À cette étape, la sélection des clients déterminera les missions EY Canvas disponibles auxquelles connecter votre projet.',
	step3InstructionHeader: 'Sélectionnez au moins une mission EY Canvas, que vous glisserez/déposerez dans votre organigramme.',
	step3InstructionPara: 'La connexion entre les missions EY Canvas et les entités dans votre organigramme permet de déterminer comment les données EY Canvas sont résumées dans le tableau de bord de votre projet.',
	availableLabel: 'Disponibles',
	connectedLabel: 'Connectées',
	milestoneSummaryView: 'Jalon ‒ vue Sommaire',
	taskCompletionByMilestone: 'Achèvement de tâche par jalon',
	basedOnTaskCompletition: 'En fonction de la progression de la tâche',
	scopeAndStrategy: 'Étendue et stratégie',
	execution: 'Exécution',
	conclusion: 'Conclusion',
	step3ListDefaultMessage: 'Il n’y a pas de mission disponible pour le ou les clients que vous avez sélectionnés à l’étape 1. Veuillez retourner à l’étape 1 et sélectionner un client différent pour continuer.',
	addNewEngagementLabel: 'Ajouter une nouvelle mission',
	selectedLabel: 'sélectionnée',
	moreText: 'plus',
	connectLabel: 'Connecter',
	connectEngagements: 'Missions connectées',
	connectToAnEngagement: 'Connecter une mission pour commencer.',
	connectToAnAccessGroup: 'Aucun groupe n’a encore été connecté.',
	tasks: 'Tâches',
	organizationalChartHeading: 'Entités',
	groupAdministratorsLabel: 'Administrateurs de groupe',
	step4InstructionHeader: 'Créer des groupes pour votre projet et connectez-les à au moins une entité de votre organigramme.',
	step4ImportantNote: 'Remarque importante : Les membres d’un groupe peuvent voir les données de la mission EY Canvas pour les entités (et les entités enfants) figurant dans l’organigramme que vous avez connectées au groupe. Si vous connectez un groupe à une entité parente dans votre organigramme, le groupe pourra voir les données de la mission EY Canvas pour l’entité parente et toutes les entités enfants.',
	addAGroup: 'Ajouter un groupe',
	addGroup: 'Ajouter un groupe',
	searchGroup: 'Rechercher des groupes',
	addNewGroupHeader: 'Créer un nouveau groupe ici.',
	editNewGroupHeader: 'Modifier un groupe existant ici.',
	addNewGroupInstruction: 'Une fois que votre projet est créé, vous pouvez inviter des membres de l’équipe internes et externes au groupe. Vous pouvez choisir d’ajouter un administrateur de groupe, qui peut à son tour inviter des membres à faire partie du groupe.',
	groupName: 'Nom du groupe',
	groupAdministrators: 'Administrateurs de groupe (facultatif)',
	groupAdministratorsSubHeading: 'Ajouter un administrateur de groupe. Les administrateurs de groupe peuvent inviter des membres à participer à un projet après sa création. Ils ne peuvent pas modifier les affichages ni les domaines qui ont été définis pour le groupe.',
	clearAllValues: 'Effacer',
	createGroupDashboardViews: 'Vues du tableau de bord',
	dashboardViewsSubHeading: "Sélectionner au moins un mode d'affichage. Cela détermine les données qui s’affichent aux membres dans le tableau de bord de votre projet.",
	duplicateDomain: 'Dupliquer le domaine',
	allMilestones: 'Tous les jalons',
	someMilestonesSelected: '{0} jalons sélectionnés',
	noGroupsAdded: 'Aucun domaine n’a été ajouté pour ce projet.',
	step5InstructionHeader: 'Passer en revue votre projet du module Surveillance d’EY Canvas.',
	step5SubInstruction: 'Si vous devez effectuer des changements, cliquez sur l’icône Modifier (crayon) pour revenir à une étape précédente. <b>Le fait d’apporter des modifications à une étape précédente peut avoir une incidence sur la progression des étapes ultérieures.</b>',
	associationNotRequired: 'Aucune association requise',
	accessGroupAlreadyAddedToParent: 'Vous avez déjà associé un ou plusieurs des groupes sélectionnés à une entité parente. Si un groupe d’accès est connecté à une entité parente, ses membres pourront voir les données de la mission EY Canvas pour l’entité parente et toutes les entités enfants. Par conséquent, aucune association n’est requise.',
	deleteGroupInstructionalText: 'Voulez-vous vraiment supprimer ce groupe? <br>La suppression ne peut pas être annulée. Les membres du groupe ne pourront plus accéder à votre projet.',
	deleteGroup: 'Supprimer le groupe',
	removeMember: 'Retirer un membre de l’équipe',
	removeMemberTitle: 'Voulez-vous vraiment retirer le membre de l’équipe? Si le membre fait partie de plusieurs groupes, il sera retiré de tous les groupes énumérés ci-après et ne pourra plus accéder à ce projet. Si vous voulez retirer le membre d’un seul groupe, sélectionnez plutôt l’option <b>Modifier</b>.',
	teamMember: 'Membre de l’équipe',
	clientNameLbl: 'Clients',
	help: 'Aide',

	//Org char left rail
	filters: 'Filtres',
	countEngagementSelected: '{0} mission(s) sélectionnée(s) sur {1}',
	of: '{num} de',
	entityName: 'Nom de l’entité',
	enterEntityName: 'Entrer le nom ici',
	projectOwner: 'Propriétaire de projet',
	role: 'Rôle',
	domains: 'Domaines (facultatif)',
	domainSubHeading: 'Ajoutez au moins un domaine si des membres de l’équipe externes sont invités dans ce groupe. Le domaine correspond aux caractères qui se trouvent après le symbole @ dans une adresse courriel. Pour ajouter un membre externe, le nom de domaine doit être valide pour le groupe.',
	addAdministrator: 'Ajouter un administrateur de groupe',
	addNewDomain: 'Ajouter un nouveau domaine',
	addExistingDomain: 'Ajouter un domaine existant',
	placeholderStep3NoEngagementMessage: 'Il n’y a pas de mission disponible pour le ou les clients que vous avez sélectionnés à l’étape 1. Veuillez retourner à l’étape 1 et sélectionner un client différent pour continuer.',
	placeholderStep3NoConnectedEngagementMessage: 'Aucune mission n’a encore été connectée.',
	placeholderStep3AllEngagementsConnected: 'Toutes les missions disponibles sont connectées à votre projet.',
	placeholderStep4NoConnectedGroupMessage: 'Aucune groupe n’est encore connecté.',
	domainName: 'Nom du domaine',
	engagementLabel: 'Mission',
	start: 'Début',
	end: 'Fin',
	suggestedEnd: 'Fin suggérée',
	status: 'État',
	thereIsNoDataToDisplay: 'Aucune donnée à afficher.',
	selectadditionalEntitiesToContinue: 'Sélectionner d’autres entités pour continuer.',
	comingSoonToDisplay: 'L’état de la composante sera bientôt disponible.',
	checkForUpdatesToDisplay: 'Vérifiez les mises à jour dans les semaines à venir.',
	userSearchPlaceholder: 'Entrer le nom ou le courriel et appuyer sur la touche Entrée pour afficher les résultats.',
	userSearchPlaceholderForExternal: 'Entrer le courriel et appuyer sur la touche Entrée pour afficher les résultats.',
	partnerInChargeInvitedToTheEngagement: 'Associé responsable de la mission invité à participer à la mission',
	partnerInChargeSignedOffOnCraSummary: 'Synthèse de l’EGR approuvée par l’associé responsable de la mission',
	eqrSignedOffOnCraSummary: 'Synthèse de l’EGR approuvée par le responsable du contrôle qualité de la mission',
	partnerInChargeSignedOffOnAuditPlan: 'Plan de mission approuvé par l’associé responsable de la mission',
	picInvited: 'Associé responsable invité',
	picSignOffCRA: 'Approbation de lʼEGR par lʼassocié responsable',
	picSignOffAuditPlan: 'Approbation du plan de mission par lʼassocié responsable',
	eqrSingOffCRA: 'Approbation de lʼEGR par le responsable de la revue de la qualité de la mission',
	overdue: 'en retard',
	outOf: 'sur',
	edit: 'Modifier',
	remove: 'Supprimer',
	add: 'Ajouter',
	admin: 'Administrateurs',
	views: 'Affichages',
	domainLabel: 'domaine',
	domainslabel: 'Domaines',
	viewLabelText: 'affichage',
	viewsLabelText: 'affichages',
	administrators: 'Administrateurs',
	none: 'Aucun',
	organizationChart: 'Organigramme',
	invalidDomainName: 'Nom du domaine invalide',
	lastRefreshed: 'Dernière actualisation',
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: 'Dernière actualisation des données de rapprochement',
	quickFilter: 'Filtre rapide',
	notApplied: 'Non appliqué',
	quickFilterInput: 'Nom du filtre rapide',
	quickFilterSubHeaderText: 'Lorsque vous aurez terminé, vous pourrez appliquer le filtre rapide pour limiter la recherche aux entités pour lesquelles vous souhaitez afficher les données sans avoir à les sélectionner une par une.',
	createFilterTrigger: 'Créer un nouveau filtre',
	createFilterTitle: 'Créer un nouveau filtre rapide',
	createFilterButton: 'Créer un filtre rapide',
	createFilterHeaderText: 'Sélectionnez au moins une entité figurant dans l’organigramme pour créer un filtre rapide.',
	createFilterSubHeaderText: 'Lorsque vous aurez terminé, vous pourrez appliquer le filtre rapide pour limiter la recherche aux entités pour lesquelles vous souhaitez afficher les données sans avoir à les sélectionner une par une.',
	editFilterTitle: 'Modifier un filtre rapide',
	editFilterHeaderText: 'Modifier ou supprimer un filtre rapide.',
	editFilterIconTitleTip: 'Modifier',
	oneRequired: 'Vous devez sélectionner au moins un filtre.',
	noFiltersCreatedTitle: 'Aucun filtre rapide n’a encore été créé.',
	noFiltersCreatedSubTitle: 'Créer un filtre rapide pour commencer.',
	clear: 'Effacer',
	completionRange: 'Plage d’achèvement',
	engagementCount: 'Nombre de missions',
	clickOnAVisualBelowToFilterTheEngagementList: 'Cliquer sur lʼun des éléments visuels ci-après pour filtrer la liste des missions.',
	organizationalChartTooltip: 'Sélectionner un organigramme pour modifier ou supprimer des entités dʼun projet du module Surveillance.',
	organizationalChart: 'Organigramme',

	//Task status chart labels
	open: 'Ouvrir',
	inProgress: 'En cours',
	inReview: 'En cours de revue',
	completeUpperCase: 'Terminé',
	taskStatusOverdue: 'En retard',
	noDataForSelections: 'Aucune donnée disponible pour les éléments sélectionnés.',
	selectOneOrMoreMilestones: 'Sélectionner un ou plusieurs jalons différents pour continuer.',
	milestoneDetailTitle: 'Jalons ‒ détails',
	taskStatusByMilestone: 'État des tâches par jalon',
	milestoneDetailSubtitle: 'En fonction de l’état de la tâche',
	basedOnAllTasksForTheSelectedMilestone: 'En fonction de toutes les tâches pour le ou les jalons sélectionnés',
	totalTasks: 'Tâches totales',
	noneSelected: 'Aucune sélection',
	nameOrEmail: 'Nom ou adresse courriel',
	remove: 'Supprimer',
	milestonesTooltipText: 'Progression de la mission par jalon',
	canvasClientPortalTooltipText: 'État de la demande, y compris les éléments venant à échéance, en retard et retournés',
	groudAuditTooltipText: 'État pour l’équipe principale et l’équipe affectée à l’audit d’une composante, y compris les éléments retournés et en retard',
	projectManagementTooltipText: 'État des notes de revue et des affectations, y compris les éléments en retard. Les clients n’auront pas accès à cette vue.',
	insightsTootipText: 'Comparaison des risques, des procédures de corroboration, de la stratégie axée sur les contrôles et des constatations entre l’équipe principale et les équipes affectées à l’audit de composantes. Les clients n’auront pas accès à cette vue.',
	reportTootipText: 'Degré de préparation du rapport, modification et état d’achèvement des tâches par pays',
	taskStatusComplete: 'État de la tâche ‒ Terminée',
	taskStatusInreview: 'État de la tâche ‒ En cours de revue',
	taskStatusInprogress: 'État de la tâche ‒ En cours',
	taskStatusOpen: 'État de la tâche ‒ Ouverte',

	//Review Notes chart labels
	reviewNotesByStatusTitle: 'Toutes les notes de revue',
	byStatus: 'Par état',
	totalNotes: 'notes totales',
	totalNotesLabel: 'Notes totales',
	openNotes: 'Notes ouvertes',
	byPriority: 'Par priorité',
	cleared: 'réglées',
	closed: 'fermées',
	low: 'Faible',
	medium: 'Modérée',
	high: 'Élevée',
	critical: 'Critique',
	notesTableTooltipContent: 'En fonction des notes ouvertes',

	// Group audit
	groupAuditTotalForms: 'Nombre total de formulaires',
	groupAuditNotSent: 'Non envoyées',
	groupAuditUnlinked: 'Non liées',
	totalTasksCapitalized: 'Nombre total de tâches',
	primary: 'Principale',
	component: 'Composante',

	//Bar chart
	are: 'sont',
	complete: 'terminés',
	noMilestoneDataForSelection: 'Aucune donnée relative au jalon à afficher pour cette phase de l’audit.',
	selectDifferentAuditPhase: 'Sélectionner une autre phase de l’audit ou sélectionner d’autres entités pour continuer.',

	//Delegate
	delegateInstruction: "Donnez des droits d’accès à un autre membre de l’équipe, afin qu’il puisse créer des projets en votre nom. Entrez le nom ou l’adresse courriel du membre de l’équipe pour commencer. Vos délégués auront accès aux mêmes clients que vous.",

	delegateAccess: 'Gérer les délégués',
	addAnother: 'Ajouter des délégués',
	hideMyDelegate: 'Masquer mes délégués',
	showMyDelegate: 'Afficher mes délégués',
	noRecord: 'Aucun résultat trouvé',
	duplicateUser: 'Cette personne a déjà les droits d’accès',
	duplicateUserMessage: 'Utilisateur déjà ajouté',
	addDelegates: 'Ajouter des délégués',
	delegateTo: 'Délégué à',
	delegateFrom: 'Délégué par',
	delegateToMsg: "Vous n’avez attribué vos droits d’accès à aucun membre de l'équipe.",
	delegateFromMsg: "Aucun membre de l’équipe ne vous a attribué ses droits d'accès.",

	// Project dashboard left rail
	searchFilterPlaceholder: 'Filtres de recherche',
	searchEntitiesPlaceholder: 'Rechercher des entités',
	outOfEngagements: '<b>{0}</b> sur <b>{1}</b> missions',
	engagementCompletedBasedOnTaskCompletion: '<b>{0}</b> mission sur <b>{1}</b> est terminée selon l’état d’avancement des tâches',
	engagementsCompletedBasedOnTaskCompletion: '<b>{0}</b> mission(s) a <b>{1}</b> de tâches terminées.',
	engagementCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> tâches terminées pour <b>{1}</b> mission',
	engagementsCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> tâches terminées pour <b>{1}</b> missions',
	engagementCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> tâches terminées pour <b>{1}</b> mission pour ce jalon',
	engagementsCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> tâches terminées pour <b>{1}</b> missions pour ce jalon',
	reportReleaseDate: 'Date de délivrance du rapport',
	partnerInvited: 'Associé invité',
	picSignoffOnCra: 'Approbation de l’EGR par l’associé responsable de l’audit',
	eqrSignoffOnCra: 'Approbation de l’EGR par le responsable du contrôle qualité de la mission',
	picSignoffOnAuditPlan: 'Approbation du plan de mission par l’associé responsable de l’audit',
	overdueLabel: 'En retard',

	//Team members
	teamMembersTitle: 'Membres de l’équipe',
	membersTitle: 'Membres',
	eyContactsTitle: 'Personnes-ressources d’EY',
	allMembersLabel: 'Tous les membres',
	internalMembersLabel: 'Membres internes',
	externalMembersLabel: 'Membres externes',
	groupsTitle: 'Mes groupes',
	projectOwnersTitle: 'Propriétaires de projets',
	projectOwnersLabel: 'Propriétaires de projet',
	projectOwnerLabel: 'Propriétaire de projet',

	//CCP
	summary: 'Sommaire',
	requestsByStatus: 'Demandes par état',
	totalRequests: 'Demandes totales',
	totalRequestsTitle: 'Nombre total de demandes',
	receivedByEy: 'Reçues par EY',
	acceptedByEy: 'Acceptées par EY',
	outstandingByEy: 'En cours',
	returned: 'Retournée',
	receivedByEyOnTime: 'Reçue par EY à temps',
	averageDaysOverdue: 'Nombre moyen de jours de retard',
	outOfReceivedAndAccepted: '<b>{0}</b> de <b>{1}</b> demandes reçues et acceptées',
	outOfStandingRequests: '<b>{0}</b> de <b>{1}</b> demandes restantes',
	outOfAverageDaysOverdue: '<b>{0}</b> de <b>{1}</b> demandes restantes',
	draftRequests: '{0} ébauches de demandes',
	noResultMessageHeader: 'Aucune donnée à afficher. Sélectionner d’autres entités pour continuer.',
	noResultMessageSubHeader: '',
	members: 'membres',
	memberLabel: 'membre',
	adminLabel: 'Admin',
	projectOwnerLabel: 'Propriétaire de projet',
	viewsLabel: 'affichages',
	metrics: 'Mesures',
	yes: 'Oui',
	no: 'Non',
	emptyMessageAvailableGroup: 'Aucun groupe n’a encore été créé. <br> Sélectionner <b>Ajouter un groupe</b> pour commencer.',
	thereIsNoDataToDisplayForThisEntity: 'Aucune donnée à afficher pour cette entité.',
	typeLabel: 'Type',
	groupsLabel: 'Groupes',
	group: 'Groupe',
	entitiesLabels: 'Entités',
	entityLabel: 'Entité',
	nameLabel: 'Nom',
	searchTeamMembers: 'Rechercher des membres de l’équipe',
	notSelectedLabel: 'Non sélectionné',
	entitiesLabel: 'Entités',
	noDataAvailableLabel: 'Aucune donnée disponible.',
	delete: 'Supprimer',
	deleted: 'Supprimé',
	addAMember: 'Ajouter un membre',
	addMemberHeaderText: 'Ajouter un nouveau membre à un ou plusieurs groupes pour votre projet.',
	teamMemberInformation: 'Information concernant le membre de l’équipe',
	teamMemberNote: 'Saisissez le nom ou l’adresse courriel du membre interne ou externe que vous souhaitez ajouter aux groupes sélectionnés. Appuyez sur la touche Entrée pour afficher les résultats.',
	selectGroupNote: 'Sélectionnez au moins un groupe. Les membres du groupe peuvent voir les données de la mission EY Canvas pour toutes les entités et les entités enfants figurant dans l’organigramme auxquelles leurs groupes sont connectés.',
	inviteAndClose: 'Inviter et fermer',
	inviteAndAddAnother: 'Inviter et ajouter un autre membre',
	contacts: 'Personnes-ressources',
	email: 'Adresse courriel',
	emailAll: 'Envoyer un courriel à tous',
	contactTeam: 'Communiquer avec l’équipe',
	emptyMessage: 'Aucune personne-ressource n’est disponible pour cette mission.',
	comingDue: 'Arrivant à échéance',
	tomorrow: 'Demain',
	next3days: 'Dans les 3 prochains jours',
	next5days: 'Dans les 5 prochains jours',
	next10days: 'Dans les 10 prochains jours',
	next30days: 'Dans les 30 prochains jours',
	comingDueNext5days: 'Arrivant à échéance (5 prochains jours)',
	entityDetails: 'Détails concernant l’entité',
	requestsByEntity: 'Requêtes par entité',
	basedOnTheSelectedCategory: 'En fonction de la catégorie sélectionnée',
	requestCount: 'Nombre de demandes',
	selectedDay: 'Jour sélectionné',
	editMember: 'Modifier un membre',
	editMemberHeaderText: 'Modifier les groupes auxquels le membre sélectionné peut accéder.',
	editaGroup: 'Modifier le groupe',
	editAGroupHere: 'Modifier un groupe ici',
	selectAnotherFrame: 'Sélectionner une autre période pour afficher les données.',
	emptyFrameShort: 'Sélectionner d’autres entités pour continuer.',
	emptyFrame: 'Sélectionner d’autres entités ou une période différente pour continuer.',
	editMemberHeaderText: 'Modifier les groupes auxquels le membre sélectionné peut accéder.',
	confirm: 'Confirmer',
	markCompleteModalInstrTextPart1: 'Voulez-vous vraiment terminer ce projet?',
	markCompleteModalInstrTextPart2: 'Si vous effectuez cette opération, elle ne pourra pas être annulée. Les projets terminés peuvent être réutilisés comme comme gabarits lors de la création d’un nouveau projet.',
	firstPage: 'Première page',
	lastPage: 'Dernière page',
	nextPage: 'Page suivante',
	prevPage: 'Page précédente',

	// Add Tag
	keyContacts: 'Contacts clés',
	customTags: 'Balises personnalisées',

	// Manage Tags
	manageTagInstructional: 'Créer de nouvelles balises personnalisées ici. Vous pouvez aussi modifier et supprimer des balises personnalisées existantes. L’utilisation de balises ajoute de la flexibilité à la gestion des contacts dans votre projet du module Surveillance d’EY Canvas.',
	emptyCustomTagsList: 'Aucune balise personnalisée n’a encore été créée.',
	manageTagTitle: 'Gérer les balises personnalisées',
	manageTagLinkButton: 'Gérer les balises',
	color: 'Couleur',
	tagName: 'Nom',
	tagDelete: 'Supprimer',
	tagCreate: 'Créer une nouvelle balise',
	customTagsHeader: 'Balises personnalisées',

	//preparer assignment tile
	totalPreparerAssignments: 'total des affectations de préparateur',
	inprogress: 'En cours',
	preparerAssignments: 'Affectations de préparateur',
	byAssignmentStatus: 'Par état d’affectation',
	taskWithoutPreparerAssignments: 'tâche sans affectation du préparateur',
	tasksWithoutPreparerAssignments: 'tâches sans affectation du préparateur',
	preparerFilterTitle: 'Préparateur',

	// reviewer assignment tile
	totalReviewerAssignments: 'total des affectations de responsable de la revue',
	taskWithoutReviewerAssignments: 'tâche sans affectation du responsable de la revue',
	tasksWithoutReviewerAssignments: 'tâches sans affectation du responsable de la revue',
	reviewerFilterTitle: 'Responsable de la revue',

	assignments: 'Affectations',
	notes: 'Notes',
	preparerNotAssigned: 'Préparateur non affecté',
	reviewerAssignments: 'Affectations du responsable de la revue',
	reviewerNotAssigned: 'Responsable de la revue non affecté',
	basedOnPreparerAssignments: 'En fonction des affectations du préparateur',
	basedOnPreparerAssignmentsOpenAndInProgress: 'En fonction des affectations du préparateur ouvertes et en cours',
	basedOnReviewerAssignments: 'En fonction des affectations du responsable de la revue',
	basedOnReviewerAssignmentsOpenAndInProgress: 'En fonction des affectations du responsable de la revue ouvertes et en cours',

	statusOpen: 'État ‒ Ouverte',
	statusInProgress: 'État ‒ En cours',
	statusClosed: 'État ‒ Fermée',
	byPriorityLow: 'Par priorité ‒ Faible',
	byPriotityMedium: 'Par priorité ‒ Modérée',
	byPriorityHigh: 'Par priorité ‒ Élevée',
	byPriorityCritical: 'Par priorité ‒ Critique',

	findingsLabel: 'Constatations',
	riskLabel: 'Risques',
	digitalAuditLabel: 'Audit numérique',
	digitalAuditStrategy: 'Stratégie d’audit numérique',
	byDigitalAuditTypeLabel: 'Par stratégie d’audit numérique',
	basedOnProfileSelection: 'En fonction du profil sélectionné',
	basedOnSelectionArchiveForm: 'En fonction du formulaire d’archivage sélectionné',
	MisstatementsByType: 'Anomalies par type',
	DeficienciesBySeverity: 'Déficiences par gravité',
	MisstatementsLabel: 'Anomalies',
	DeficienciesLabel: 'Déficiences',
	primarTeamDeficiencyHeader: 'Équipes principales - {0}',
	componentRegionalTeamDeficiencyHeader: 'Équipes zonales et affectées à l’audit de composantes - {0}',
	auditTileHeaderTextPrimary: 'Équipes principales - {0}',
	componentRegionalTeamHeader: 'Équipes zonales et affectées à l’audit de composantes - {0}',
	allTeamDeficiencyHeader: 'Toutes les missions - {0}',
	primarTeamMisstatementHeader: 'Équipes principales - {0}',
	componentRegionalTeamMisstatementHeader: 'Équipes zonales et affectées à l’audit de composantes - {0}',
	allTeamMisstatementHeader: 'Toutes les missions - {0}',
	deficiencyLabel: 'Déficience',
	inherenRisktLabel: 'Risque d’anomalies significatives',
	significantRiskLabel: 'Important',
	fraudRiskLabel: 'Fraude',
	significantDeficiencyLabel: 'Déficience importante',
	materialWeaknessLabel: 'Faiblesse significative',
	factualLabel: 'Factuelle',
	projectedLabel: 'Extrapolée',
	judgmentalLabel: 'Discrétionnaire',
	reclassificationLabel: 'Reclassement',
	totalDeficiencyLabel: 'déficience au total',
	totalRiskLabel: 'risque au total',
	totalRisksLabel: 'risques au total',
	totalDeficienciesLabel: 'déficiences au total',
	totalMisstatementLabel: 'anomalie au total',
	totalMisstatementsLabel: 'anomalies au total',
	allEngagementHeader: 'Toutes les missions - {0}',
	noAuditSightGroupData: '<b>Aucune donnée de l’audit de groupe à afficher.</b> <br>Sélectionnez <b> Tout </br> à l’aide du bouton à bascule pour afficher les données résumées.',
	noAuditTileDataPlaceholder: 'Aucune donnée à afficher. Sélectionner d’autres entités pour continuer.',
	openReviewNotes: 'Notes de revue ouvertes',
	byPriorityLevel: 'Par priorité',
	risks: 'Risques',
	groupRoleLabel: 'Rôle dans l’audit de groupe',
	totalRisks: 'Total des risques',
	byType: 'Par type',
	inherent: 'Risque d’anomalies significatives',
	significant: 'Important',
	fraud: 'Fraude',
	strategy: 'Stratégie',
	notApplicable: 'Sans objet',
	customizableTable: 'Tableau à personnaliser',
	selectUpToOptionHeader: 'Sélectionnez jusqu’à {0} options',
	selectUpToThreeOptionHeader: "Sélectionnez jusqu'à trois options",
	selectUpToFourOptionHeader: "Sélectionner jusqu'à quatre options",
	psps: 'PCB',
	osps: 'APC',
	hxpsps: 'PCB.hx',
	totalSubstantiveProcedures: 'procédures de corroboration au total',
	totalSubstantiveProcedure: 'procédures de corroboration au total',
	totalITControls: 'CGI et procédures de corroboration liées aux TI au total',
	totalITControl: 'CGI et procédures de corroboration liées aux TI au total',
	testing: 'Tests',
	nonTesting: 'Aucun test',
	auditStrategy: 'Stratégie d’audit',
	totalControls: 'contrôles au total',
	totalControl: 'contrôle au total',
	removeProject: 'Retirer le projet',
	removeProjectInstructionalText: 'Voulez-vous vraiment retirer le projet suivant de la liste de vos projets actifs? <br>Si vous retirez le projet, vous ne pourrez plus y accéder.',
	substantiveProcedures: 'Corroboration',
	controls: 'Contrôles',
	itlabel: 'TI',

	//delegates removed
	userDelTitle: 'Mes délégués',
	delTitleDetail: 'Vous avez donné vos droits d’accès aux membres de l’équipe suivants. Vos délégués auront accès aux mêmes clients que vous.',
	delElseMsg: 'Vous n’avez pas encore nommé de délégué.',
	delegateTitle: 'Retirer un délégué',
	delegateMember: 'Déléguées',
	deleteMessage: 'Voulez-vous vraiment retirer cette personne de la liste de vos délégués?<br/> Une fois qu’elle aura été retirée de la liste, elle ne pourra plus créer de projet en votre nom.',

	//Advanced filters.
	advancedFilters: 'Filtres avancés',
	selectAll: 'Tout sélectionner',
	deselectAll: 'Tout désélectionner',
	applyFilters: 'Appliquer les filtres',
	region: 'Zone',
	country: 'Pays',
	city: 'Ville',
	state: 'État',
	advancedFiltersInstructionalText: 'Sélectionnez les entités pour lesquelles vous souhaitez voir les données de la mission',
	advancedFiltersInstructionalTextLine2: "Les entités auxquelles vous n’avez pas accès semblent être désactivées. Communiquez avec un administrateur de groupe pour obtenir les droits d'accès.",
	engagementsSelected: 'mission(s) sélectionnée(s)',
	filterYes: 'Oui',
	filterNo: 'Non',

	//Group Audit
	pendingResponse: 'En attente d’une réponse',
	primaryTileTitle: 'État de l’équipe principale',
	reportingFormStatus: 'État du formulaire de rapport',
	reportingForm: 'Formulaire de rapport',
	summarizedForPrimaryTeams: 'Résumé pour les équipes principales',
	primaryTileSubtitle: 'formulaires de rapport pour l’audit de groupe envoyés',
	received: 'Reçue',
	dueToPrimaryTeam: 'À livrer à l’équipe principale',
	sentToPrimaryTeam: 'Envoyée à l’équipe principale',
	evidencePending: 'En attente d’éléments probants',
	evidenceComplete: 'Éléments probants terminés',
	componentTileTitle: 'État de l’équipe affectée à l’audit d’une composante',
	componentTaskStatus: 'État de la tâche de la composante',
	componentTask: 'Tâche de la composante',
	comingsoonTaskStatus: 'Bientôt disponible',
	summarizedForComponentTeams: 'Résumé pour les équipes affectées à l’audit de composantes',
	componentTileSubtitle: 'tâches pour l’audit de groupe reçues',
	unlinkedTask: 'tâche non liée',
	unlinkedTasks: 'tâches non liées',

	//Group Risk Assessment
	groupRiskAssessmentTitle: 'Risques',
	groupRiskSummaryTitle: 'Évaluation des risques à l’échelle du groupe',

	// Reporting
	reportModifications: 'Modifications apportées au rapport',
	byReportType: 'Par type de rapport',
	notSelected: 'Non sélectionné',
	unmodified: 'Non modifié',
	modified: 'Modifié',
	reports: 'Rapports',
	opinions: 'opinions',
	modifiedReports: 'Rapports modifiés',
	modifiedOpinions: 'Opinions modifiées',
	adverse: 'Défavorable',
	disclaimer: 'Impossibilité d’exprimer une opinion',
	qualification: 'Réserve',
	qualified: 'Avec réserve',
	engagementReportTooltip: 'Seules les missions dont la date de rapport correspond à la date du jour ou avant figurent dans la liste suivante. Toutes les missions sont affichées dans le tableau ci-après.',
	geography: 'Situation géographique',
	standars: 'Normes',
	gaap: 'PCGR',
	gaapUs: 'PCGR des É.-U.',
	ifrs: 'IFRS',
	other: 'Autre',
	yearEndDate: 'Date de fin d’exercice',
	endDateOfPeriodCovered: 'Date de fin de la période visée',
	reportDate: 'Date du rapport',
	archiveDeadline: 'Date d’échéance de l’archivage',
	reportType: 'Type de rapport',
	opinionType: 'Type d’opinion',
	taskStatus: 'État de la tâche',
	exportData: 'Exporter des données',
	exportToExcel: 'Exporter',
	orgChartEntity: 'Entité figurant dans l’organigramme',
	engagementId: 'Identifiant de la mission',
	contactName: 'Nom de la personne-ressource',
	contactEmail: 'Courriel de la personne-ressource',
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: 'Par type ‒ Important',
	statusFraud: 'Par type ‒ Fraude',
	substantivePSPs: 'Corroboration ‒ PCB',
	substantiveOSPs: 'Corroboration ‒ APC',
	substantiveHxPSPs: 'Corroboration ‒ PCB.hx',
	controlsTesting: 'Contrôles ‒ Tests',
	controlsNonTesting: 'Contrôles ‒ Aucun test',
	iTTesting: 'TI ‒ Tests',
	iTNonTesting: 'TI ‒ Aucun test',
	misstatementsFactual: 'Anomalies ‒ Factuelles',
	misstatementsProjected: 'Anomalies ‒ Extrapolées',
	misstatementsJudgmental: 'Anomalies ‒ Liées au jugement',
	misstatementsReclassification: 'Anomalies ‒ De reclassement',
	deficienciesDeficiency: 'Déficiences ‒ Déficience',
	deficienciesSignificantdeficiency: 'Déficiences ‒ Déficience importante',
	deficienciesMaterialweakness: 'Déficiences ‒ Faiblesse significative',
	statusComplete: 'État ‒ Terminée',
	statusInReview: 'État ‒ En cours de revue',
	statusInProgress: 'État – En cours',
	statusOpen: 'État ‒ Ouverte',
	statusNotSent: 'État ‒ Non envoyée',
	statusReturned: 'État ‒ Retournée',
	statusDocumentationPending: 'État ‒ Documentation en attente',
	statusDocumentationComplete: 'État ‒ Documentation terminée',
	statusReceivedbyEY: 'État ‒ Reçue par EY',
	statusAcceptedbyEY: 'État ‒ Acceptée par EY',
	statusOutstanding: 'État ‒ En suspens',
	noCompletedProjectsMessagePart1: 'Vous n’avez aucun projet terminé.',
	noCompletedProjectsMessagePart2: 'Si vous êtes propriétaire du projet, vous pouvez indiquer le projet comme étant terminé. Les projets terminés peuvent être réutilisés comme comme gabarits lors de la création d’un nouveau projet.',
	noCompletedProjectsMessage: 'Vous n’avez aucun projet terminé. <br>Si vous êtes propriétaire du projet, vous pouvez désigner le projet comme étant terminé. Les projets terminés peuvent être réutilisés comme gabarits lors de la création d’un nouveau projet.',
	requests: 'Demandes',

	//Reporting readiness report
	week: 'semaine',
	weeks: 'semaines',
	readinessReportTitle: 'État de préparation du rapport',
	taskCompletionByEngagement: 'Achèvement de tâche par mission',
	readinessLegendTitle: 'Proximité de la date du rapport',
	basedOnReportDateProximityForEachEngagement: 'En fonction de la proximité de la date du rapport pour chaque mission',

	//ReportCompletion
	taskCompletionStatus: 'État d’achèvement de la tâche',
	taskCompletionByLocation: 'Achèvement de tâche par emplacement',
	basedOnCompletedTasksForEachEngagement: 'En fonction des tâches terminées pour chaque mission',
	byGeography: 'Par situation géographique',
	taskCompletion: 'Achèvement de la tâche',
	completedTasks: 'tâches terminées',

	engagementArchived: 'Cette mission a été archivée. Les données ne sont plus disponibles.',
	externalUsersNoActiveProjMessage: "Vous n’avez aucun projet actif. Veuillez communiquer avec un membre de l’équipe EY pour obtenir l'accès.",

	//Error Messages
	networkErrorMessage: 'Une erreur s’est produite dans le réseau d’application. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.',
	genericErrorMessage: 'L’opération sélectionnée ne peut pas être traitée pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.',
	otherProjectPlaceholder: 'Vos missions EY Canvas sont connectées aux projets Oversight EY Canvas suivants. Vous n’avez pas accès à ces projets. Communiquez avec un des propriétaires des projets ou à un administrateur du groupe  pour obtenir l’accès.',
	noProjectsAvailable: 'Aucun projet disponible.',
	completedProjectPlaceholder: 'Voici la liste des projets Oversight EY Canvas que vous avez terminés. Sélectionnez l’option <b> Récupérer </b> pour réutiliser votre projet terminé comme gabarit pour créer un nouveau projet.',
	completedNotProjectPlaceholder: 'Vous n’avez aucun projet terminé. <br>Si vous êtes propriétaire du projet, vous pouvez désigner le projet comme étant terminé. Les projets terminés peuvent être réutilisés comme gabarits lors de la création d’un nouveau projet.',

	//Log out and time out modal
	logoutModalTitle: 'Déconnexion automatique pour votre protection',
	sessionTimerMsgLine1: 'Votre session prendra fin bientôt pour cause d’inactivité.',
	sessionTimerMsgLine2: 'Par souci de sécurité, les sessions ouvertes dans le module Surveillance d’EY Canvas prennent fin automatiquement après 30 minutes d’inactivité.',
	sessionTimerMsgLine3: 'Votre session actuelle expirera dans {0} minutes.',
	sessionTimerMsgLine4: 'Pour maintenir votre connexion, cliquez sur',
	modalContinueButton: '<b>Continuer</b>',
	modalLogoutButton: 'Se déconnecter',
	modalCloseButton: 'Fermer',
	countryNotAvailable: 'Pays non disponible',
	regionNotAvailable: 'Zone non disponible',
	notAvailable: 'Non disponible',
	signout: 'Se déconnecter',
	engagementTypeNotAvailable: 'Type de mission non disponible',

	// Admin portal
	administration: 'Administration',
	mainPageInstructionalText: 'Bienvenue sur le portail administratif du module Surveillance d’EY Canvas',
	manageProjectsFormatted: 'Gérer <br />les projets',
	manageUsersFomatted: 'Gérer <br />les utilisateurs',
	manageAdminsFormatted: 'Gérer <br />les administrateurs du module Surveillance',
	homeLabel: 'Accueil',
	userNotFoundError: 'Utilisateur introuvable.',
	manageUsersInstructionalText: 'Rechercher un utilisateur à l’aide de leur identifiant global unique (GUI)',
	selectRole: 'Sélectionner un rôle',
	role: 'Rôle',

	//Manage User
	manageUsersTitle: 'Gérer les utilisateurs',
	otherProjectsTabTitle: 'Autres projets',
	validGuiErrorMsg: 'Entrer un identifiant global unique (GUI) valide',
	accessibleProjects: 'Projets accessibles',
	delegates: 'Délégués',
	projectID: 'Identifiant du projet',
	projectStatus: 'État du projet',
	gui: 'Identifiant global unique (GUI)',
	emailAddress: 'Adresse courriel',
	userRole: 'Rôle de l’utilisateur',
	userID: 'Identifiant de l’utilisateur',
	noResultMessage: 'Les critères de recherche ne donnent aucun résultat.',
	noResultFound: 'Aucun enregistrement trouvé',
	userDetails: 'Renseignements sur l’utilisateur',
	active: 'Actif',
	inActive: 'Inactif',
	manageAdmins: 'Gérer les administrateurs du module Surveillance d’EY Canvas',
	manageAdminsInstructionalText: 'Voici la liste des administrateurs du module Surveillance d’EY Canvas. Vous pouvez modifier les rôles d’un administrateur ou ajouter et supprimer des administrateurs.',
	adminReader: 'Admin-lecture de l’application',
	adminWriter: 'Admin-écriture de l’application',
	superAdmin: 'Super-admin de l’application',
	revertChanges: 'Annuler les changements',
	unSavedChanges: 'Changements non enregistrés',
	unSavedChangesMessage: 'Si vous continuez, les changements non enregistrés seront perdus. <br/> Sélectionnez <b>Confirmer</b> pour continuer. Sélectionnez <b>Annuler</b> pour revenir à la page précédente et enregistrer les changements.',
	addNewAdmin: 'Ajouter un nouvel administrateur',
	addEYContactInstructions: 'Entrez le nom ou l’adresse courriel et appuyez sur la touche Entrée pour afficher les résultats. Sélectionnez un rôle pour ajouter un nouvel administrateur du module Surveillance.',

	// ManageProjects
	orgChartEntities: 'Entités figurant dans l’organigramme',
	manageProjectsInstructionalText: 'Rechercher un projet par son identifiant',
	projectDetails: 'Détails du projet',
	parentEntity: 'Entité parent',
	connectedGroups: 'Groupes connectés',
	validProjectIDError: 'Entrer un identifiant de projet valide',
	addNewMember: 'Ajouter un membre',
	adminAddMemberInstructionalText: 'Chercher un utilisateur et sélectionner les groupes auxquels il doit être ajouté.',
	currentApplication: 'Application actuelle',

	//Software Update
	softwareUpdate: 'Mises à jour logicielles',
	updateNow: 'Mettre à jour maintenant',
	updateMsg: 'Des mises à jour logicielles sont disponibles pour le module Surveillance d’EY Canvas. Sélectionnez Mettre à jour maintenant pour télécharger et installer les mises à jour. La page sera actualisée.',

	//ContactDB
	placeholderForSearch: 'Rechercher',
	contactClearAll: 'Tout effacer',
	contactShowMoreFilters: 'plus',
	contactListFilter: 'Accéder à la liste de contacts',
	dashboardAccessFilter: 'Accéder au tableau de bord',
	groupRoleFilter: 'Rôle dans l’audit de groupe',
	tagFilter: 'Balises',
	countryFilter: 'Pays',
	serviceLineFilter: 'Gamme de services',
	typeFilter: 'Type',
	roleFilter: 'Rôle',
	dashboardAccess: 'Accès au tableau de bord',
	contactList: 'Liste des contacts',
	noEntitiesMessage1: 'Aucune donnée à afficher.',
	noEntitiesMessage2: 'Sélectionner d’autres entités pour continuer.',
	noContacts: 'Aucun contact pour cette entité.',
	engagementsContacts: 'Missions',
	manuallyAdded: 'Ajouté manuellement',
	dashboardViews: 'vues',
	columnName: 'Nom',
	columnEmail: 'Adresse courriel',
	columnEngagement: 'Missions',
	columnType: 'Type',
	columnRole: 'Rôle',
	columnServiceLine: 'Gamme de services',
	columnDashboard: 'Accéder au tableau de bord',
	columnDashboardView: 'Vues du tableau de bord',
	columnContactList: 'Accéder à la liste de contacts',
	columnTags: 'Balises',
	columnEntity: 'Entité',
	noResults: 'Aucun résultat trouvé',
	noResultsAvailable: 'Aucune donnée disponible.',
	searchContacts: 'Rechercher des contacts',
	selectedContacts: 'Contacts sélectionnés',
	tag: 'Balise',
	manageAccess: 'Gérer l’accès',
	formLengthMessage: 'Le texte ne doit pas dépasser {number} caractères.',
	viewMoreColumns: 'Afficher plus de colonnes',
	projectOwnerBadge: 'Propriétaire de projet',
	entityAdminBadge: 'Administrateur de l’entité',
	eyTeam: 'Équipe EY',
	clientTeam: 'Équipe Client',
	userProfile: 'Profil d’utilisateur',
	columnGroupRiskAssessment: 'Accéder à l’évaluation des risques au niveau du groupe',
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: 'Ajouter un contact',
	toolbarAccessLog: 'Journal des accès',
	toolbarMessageLog: 'Journal des messages',
	toolbarCustomizeTable: 'Personnaliser le tableau',
	toolbarExportData: 'Exporter des données',
	toolbarManageAccess: 'Gérer les accès',
	toolbarDefineAttributes: 'Définir les attributs',
	toolbarGenerateMessage: 'Générer le message',
	toolbarTags: 'Balises',
	toolbarRemove: 'Retirer',

	//ContactDB - Add Contact Modal
	addContactLabel: 'Ajouter un contact',
	addContactTitle: 'Ajouter des contacts',
	addContactInstructional: 'Ajoutez un ou plusieurs contacts à votre projet du module Surveillance d’EY Canvas. Pour donner accès au tableau de bord ou à la liste de contacts aux contacts que vous ajoutez, cliquez ici.',
	columnEntities: 'Entités',
	noEntities: 'Aucune',
	duplicatedUser: 'a déjà été ajouté(e) comme contact. Vous pouvez gérer son accès à partir de la liste des contacts.',
	accessToDashboard: 'Accéder au tableau de bord',
	dashBoardsViews: 'Accès au tableau de bord et vues du tableau de bord',
	placeholderEntities: 'Entités',
	placeholderAccess: 'Accès',
	placeholderAttributes: 'Attributs',
	placeholderTags: 'Balises',
	projectOwnerAccessLabel: 'Accès du propriétaire de projet',
	entityAdminAccessLabel: 'Accès de l’administrateur de l’entité',
	accessToContactListLabel: 'Accéder à la liste de contacts',
	saveContactLabel: 'Enregistrer',
	cancelContactLabel: 'Annuler',
	noContactsAdded: 'Aucun contact n’a encore été ajouté.',
	noCustomColumns: 'Aucune colonne personnalisée n’a été créée pour votre projet.',
	toggleContactYes: 'Oui',
	toggleContactNo: 'Non',
	mustSelectOneEntity: 'Vous devez sélectionner au moins une entité pour continuer.',
	mustSelectOneView: 'Sélectionnez au moins une vue pour tous les contacts à qui vous donnez accès au tableau de bord du module Surveillance d’EY Canvas.',
	mustBeOnwerOrAdministrator: 'Vous devez être propriétaire du projet ou administrateur de l’entité pour effectuer cette action. Veuillez mettre à jour les entités sélectionnées pour continuer.',
	cannotEditAccessForProjectOwners: 'Vous ne pouvez pas modifier l’accès des propriétaires de projet suivants : {list}',
	attributesLabel: 'Attributs',
	externalUserDomainMismatch: 'Le domaine n’est pas autorisé pour une entité sélectionnée ou plus. Ajoutez les domaines requis au flux de configuration de l’entité et réessayez.',
	projectOwnerAccessToogleInfo: 'Le propriétaire de projet dispose de toutes les autorisations pour un projet du module Surveillance d’EY Canvas.',
	entityAdminAccessToogleInfo: 'L’administrateur de l’entité dispose d’autorisations propres à l’entité pour effectuer des tâches administratives, au besoin.',

	//ContactDB-CustomizeTable Modal
	customizeTableModal: 'Personnaliser le tableau',
	InstructionalTextCustomizeTableModal: 'Select the columns you would like to view.',
	cancelCustomizeTable: 'Annuler',
	saveCustomizeTable: 'Enregistrer',
	tooltipCustomizeTable: 'Personnaliser le tableau',
	standardColumns: 'Colonnes standards',
	customColumns: 'Colonnes personnalisées',
	closeTitleModal: 'Fermer',
	addCustomColumn: 'Ajouter une colonne personnalisée',
	editCustomColum: 'Modifier la colonne personnalisée',
	addCustomColumnLegend: 'Les colonnes personnalisées permettent de saisir et de gérer des attributs additionnels pour vos contacts. Vous pouvez créer jusqu’à cinq colonnes personnalisées pour votre projet. Après avoir créé une colonne, vous pouvez sélectionner un ou plusieurs contacts et définir un attribut. Si vous supprimez une colonne personnalisée, les attributs définis pour les contacts seront supprimés.',
	deleteCustomColumnLegend: 'Cliquez sur <b>Supprimer</b> pour supprimer une colonne personnalisée. Si vous poursuivez, la colonne ne sera plus disponible pour votre projet. Tout attribut appliqué précédemment aux contacts sera également supprimé.',
	customColumnName: 'Nom de la colonne',
	attribute: 'Attribut',
	attributes1to5: 'Attributs (1 à 5)',
	visibleToExternal: 'Visible pour les contacts externes',
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: 'Filtre',
	searchTitletip: 'Recherche',
	addExternalContactColumnName: 'Nom',
	addExternalContactColumnDomain: 'Domaine',
	confirmDomain: 'Confirmer le domaine',

	//ContactDB - Profile Modal
	profileModalTitle: 'Profil',
	profileModalAccessSection: 'Accès',
	profileModalCustomAttributesSection: 'Personnaliser les attributs',
	profileModalDashboardSection: 'Vues du tableau de bord',

	//ContactDB - Generate Message
	selectMessageRecipients: 'Sélectionner les destinataires du message',
	notification: 'Notification',
	generateMessage: 'Générer le message',
	gmInstructionalText: "Envoyer un courriel ou une notification aux contacts que vous avez sélectionnés. Les notifications ne peuvent être envoyées qu’à des contacts internes. Les courriels peuvent être envoyés à des contacts internes et externes.",
	messageType: 'Type de message',
	messageRecipient: 'Destinataires du message',
	selectContactsNow: 'Sélectionner les contacts maintenant',
	useSelectedContacts: 'Utiliser les contacts sélectionnés',
	moreFilters: '+ Plus de filtres',
	countries: 'Pays',
	groupRoles: 'Rôles dans l’audit de groupe',
	groupRole: 'Rôle dans le groupe',
	roles: 'Rôles',
	role: 'Rôle',
	serviceLines: 'Gammes de services',
	serviceLine: 'Gamme de services',
	contatcs: 'Contacts',
	singularContact: 'Contact',
	singularEngagement: 'Mission',
	allContact: 'Tous les contacts',
	allEntitles: 'Toutes les entités',
	allCountries: 'Tous les pays',
	allGroupRoles: 'Tous les rôles dans l’audit de groupe',
	allEngagements: 'Toutes les missions',
	allServicesLines: 'Toutes les gammes de services',
	allRoles: 'Tous les rôles',
	subject: 'Objet',
	removeTooltip: 'Retirer',
	fromEntity: 'D’une entité',
	fromEngagement: 'D’une mission',
	notificationMessage: 'Message de notification',
	linkLabel: 'Étiquette du lien (facultatif)',
	link: 'Lien (facultatif)',
	fromEntityNotification: 'D’une entité',
	mustSelectOne: 'Vous devez sélectionner au moins un contact pour continuer.',
	emailSentMsg: 'Un courriel a été envoyé aux contacts sélectionnés.',
	notificationSentMsg: 'Une notification a été envoyée aux contacts sélectionnés.',
	messageFrom: 'Message de',
	duplicateMessage: 'Message en double',
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: 'Passez en revue la liste des messages envoyés par votre entité. Pour envoyer un message de suivi, vous pouvez dupliquer les messages précédents.',
	messageLogTitle: 'Journal des messages',
	today: 'Aujourd’hui',
	yesterday: 'Hier',
	thisWeek: 'Cette semaine',
	lastWeek: 'La semaine dernière',
	twoWeeksAgo: 'Il y a deux semaines',
	older: 'Plus ancien',
	notificationTo: 'Notification à',
	emailTo: 'Courriel à',
	sentBy: 'Envoyé par',
	from: 'De',
	date: 'Date',
	time: 'Heure',
	subject: 'Objet',
	multiContatcsLowerCase: 'contacts',
	singleContactLowerCase: 'contact',
	seeMore: 'Afficher plus',
	seeLess: 'Afficher moins',
	messageLogEmptyMessage: 'Aucun message n’a encore été envoyé.',
	messageLogFileExported: 'Journal des messages',
	typeColumnToExportToExcel: 'Type',
	sentByColumnToExportToExcel: 'Envoyé par',
	fromColumnToExportToExcel: 'De',
	dateColumnToExportToExcel: 'Date',
	timeColumnToExportToExcel: 'Heure',
	subjectColumnToExportToExcel: 'Objet',
	contactsColumnToExportToExcel: 'Contacts',
	emailExportToExcel: 'Adresse courriel',
	notificationExportToExcel: 'Notification',

	//ContactDB - Access Log
	accessLog: 'Journal des accès',
	accessLogInstructional: 'Veuillez passer en revue les membres de l’équipe ci-après et décider si vous les ajoutez à vos contacts ou les en retirer.',
	addAll: 'Ajouter tous les membres',
	removeAll: 'Retirer tous les membres',
	ignoreAll: 'Ignorer tous les membres',
	contactsToAddEmpty: 'Il n’y a aucun contact potentiel à ajouter pour le moment.',
	contactsToRemoveEmpty: 'Il n’y a aucun contact potentiel à retirer pour le moment.',
	ignore: 'Ignorer',
	addAllConfirmationModal: 'Un utilisateur ou plus a un domaine qui n’est pas permis par une entité. Cliquez sur Continuer pour ajouter les utilisateurs à la liste des contacts. Le ou les domaines seront importés et ajoutés à la liste des domaines permis pour l’entité.',
	addConfirmationModal: 'L’utilisateur a un domaine qui n’est pas permis par cette entité. Cliquez sur Continuer pour ajouter l’utilisateur à la liste des contacts. Le domaine sera importé et ajouté à la liste des domaines permis pour l’entité.',

	// ContactDB - Message Log - Filter
	messageTypeFilter: 'Type de message',
	sentByFilter: 'Envoyé par',
	fromEntityFilter: 'Dʼune entité',
	toEntityFilter: 'À une entité',
	toCountryFilter: 'À un pays',
	toGroupRoleFilter: 'À un rôle dans lʼaudit de groupe',
	toEngagementFilter: 'À une mission',
	toServiceLineFilter: 'À une gamme de services',
	toRoleFilter: 'À un rôle',

	//ContactDB - Define Attributes
	defineAttributes: 'Définir les attributs',

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: 'Ajouter un autre administrateur de l’entité',
	editEntity: 'Modifier l’entité',
	entityAdministrators: 'Administrateurs de l’entité (facultatif)',
	editEntityAdministratorsInstruction: 'Vous pouvez choisir d’ajouter un ou plusieurs administrateurs de l’entité. Ils peuvent ajouter des contacts à cette entité et donner accès aux projets du module Surveillance d’EY Canvas.',
	editEntityDomainInstruction: 'Les membres de l’équipe externes doivent avoir un domaine valide pour cette entité afin d’accéder au module Surveillance d’EY Canvas. Le système importera les domaines approuvés à partir des missions EY Canvas connectés à l’étape 4 de l’assistant de configuration. Si vous prévoyez d’inviter d’autres membres de l’équipe externes à accéder à cette entité, vous devez alors ajouter un ou plusieurs domaines. Le domaine correspond aux caractères qui se trouvent après le symbole @ dans une adresse courriel.',
	level: 'Niveau {0}',

	// ContactDB Remove Contacts
	removeIcon: 'Retirer',
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: 'Voulez-vous vraiment retirer ces contacts de votre projet? Si ces contacts appartiennent à plusieurs entités, ils seront retirés de toutes les entités. Pour retirer un contact d’une seule entité, sélectionnez plutôt le contact pour modifier ses accès.',
	removeSelectedContacts: 'Contacts sélectionnés',

	domainNotPermitted: 'Le domaine pour un ou plusieurs des administrateurs de l’entité n’est pas autorisé pour cette entité.',
	listView: 'Vue Liste',
	cardView: 'Vue Carte',

	recordsNotAvailable: 'Aucun enregistrement disponible',

	// Project Layout Update
	welcomeLabel: 'Bienvenue',
	activeProjectsInstructionalText: 'Vous avez accès aux projets du module Surveillance d’EY Canvas suivants. Sélectionnez un module pour y accéder ou cliquez sur un nombre pour afficher les détails de chacun de vos projets.',
	otherProjectsInstructionalText: 'Vos missions EY Canvas sont connectées aux projets du module Surveillance d’EY Canvas suivants. Vous n’avez pas accès à ces projets. Communiquez avec un propriétaire de projet ou un administrateur de l’entité pour obtenir l’accès.',
	completedProjectsInstructionalText: 'Voici la liste des projets du module Surveillance d’EY Canvas que vous avez terminés. Sélectionnez l’option <b>Récupérer</b> pour réutiliser votre projet terminé comme gabarit pour créer un nouveau projet.',
	goToLabel: 'Accéder à',
	entityAdmins: 'Administrateurs de l’entité',
	entityAdmin: 'Administrateur de l’entité',
	keyContacts: 'Contacts clés',
	keyContact: 'Contact principal',
	contactListLabel: 'Liste des contacts',
	draftlabel: 'Projet',
	projectWizard: 'Assistant Projet',
	noEntityAdminsAdded: 'Aucun administrateur de l’entité associé',
	addProjectOwner: 'Ajouter un propriétaire de projet',
	addProjectOwnerInstrText: 'Rechercher un utilisateur par son nom ou son courriel pour lʼajouter en tant que propriétaire de projet du projet sélectionné.',
	projectSummary: 'Synthèse du projet',
	privacyNotice: 'Avis de confidentialité',
	groupOversightProject: 'Projet du Surveillance d’EY Canvas pour les audits de groupe (Nouveau!)',
	groupOversightProjectTooltip: 'Dans les <b>projets du module Surveillance pour les audits de groupe</b>, vous pouvez identifier les missions EY Canvas de l’équipe principale/zonale pour lesquelles vous créez un projet dans le module Surveillance d’EY Canvas. Les missions EY Canvas de l’équipe zonale et/ou des équipes affectées à l’audit des composantes identifiées dans la structure de l’audit de groupe dans EY Canvas seront <b>automatiquement</b> intégrées lors de la configuration du projet dans le module Surveillance d’EY Canvas. <br><br> De plus, ce type de projet permet d’accéder au module Évaluation des risques au niveau du groupe à partir duquel il est possible d’afficher les activités d’évaluation des risques par mission de l’équipe principale, zonale ou affectée à l’audit des composantes.',
	oversightProject: 'Projet du module Surveillance (audits légaux)',
	oversightProjectTooltip: 'Dans les projets du module Surveillance (audits légaux), vous pouvez sélectionner manuellement vos clients, puis vos missions EY Canvas qui y sont associées, pour lesquelles vous créez un projet dans le module Surveillance d’EY Canvas.',

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: 'Il n’y a aucune activité d’évaluation des risques au niveau du groupe pour ce projet du module Surveillance d’EY Canvas.',
	engagementData: 'Données de la mission',
	engagementDetails: 'Renseignements sur la mission',
	reconciliations: 'Rapprochements',
	nextComponent: 'Composante suivante',
	prevComponent: 'Composante précédente',
	allAccounts: 'Tous les comptes',
	generateEmail: 'Générer le courriel',
	reconciliationDetailInstructional: 'The information below summarizes the total number of Primary Team accounts, and risks of material misstatement, which were related to the component in the Primary Team\'s EY Canvas engagement and included in the group risk assessment communications. Select a Primary Team account/risk to relate it to the equivalent account/risk in the component team\'s EY Canvas engagement.',
	primaryTeamAccountName: 'Primary Team account name',
	componentTeamAccountName: 'Nom du compte de l’équipe affectée à l’audit de la composante',
	designation: 'Désignation',
	openAccounts: 'Comptes ouverts',
	componentTeamAccounts: 'Comptes de l’équipe affectée à l’audit de la composante',
	componentTeamAccountsAndPsp: 'Component team accounts and related PSP Index(es)',
	mapAccountsMessage: 'Each Primary Team account should have at least one related component team account. {button} to get started.',
	primaryTeamAccountStatus: 'Primary Team account status',
	totalAccounts: 'Nombre total de comptes',
	assessedAccounts: 'Comptes évalués',
	primaryTeamRiskStatus: 'Primary Team risk status',
	openRisks: 'Risques ouverts',
	assessedRisks: 'Risques évalués',
	totalRisks: 'Total des risques',
	primaryTeamRiskDesignationAndName: 'Primary Team risk designation and name',
	primaryTeamAccountsRelatedToRisk: 'Compte(s) associé(s) au risque – Équipe principale',
	componentTeamRisksAndRelatedAccounts: 'Risques et compte(s) associé(s) – Équipe affectée à l’audit de la composante',
	relateRisks: 'Risques associés',
	relateRisksMessage: 'Each Primary Team risk should have at least one related component team risk. {button} to get started.',
	pspIndexesHeader: 'PCB',
	pspIndexes: 'Référence(s) PCB',
	markAssessed: 'Marquer comme étant évalué',
	markReOpen: 'Rouvrir',
	riskMarkAssessedMessage: 'View related component team risks to assess whether risk designations, accounts and relevant assertions match the Primary Team risks and accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	riskWasPreviousAssessedMessage: "Status changed from Assessed to Open due to changes in the related risk, risk designation, account or assertions. Re-assess the risk grouping. When complete, {button}.",
	riskMarkOpenMessage: 'If changes need to be made to a risk grouping that has already been marked assessed, {button} the risk grouping. This risk grouping will appear in the Open risks view.',
	markAssessedSuccessMessage: 'The account grouping has successfully been marked assessed. To review, click \'Assessed accounts\' in the account status tile.',
	reopenAssessedAccount: 'Rouvrir',
	reopenAssessedAccountMessage: 'If changes need to be made to an account grouping that has already been marked assessed, {button} the account grouping. This account grouping will appear in the Open accounts view.',
	reopenSuccessMessage: 'The account grouping has successfully been re-opened. To view, click \'Open accounts\' in the account status tile.',
	teamAccountMappedMessage: 'View related component team accounts to assess whether account designations, relevant assertions and inherent risk assessments match the Primary Team accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	teamAccountWasPreviousAssessedMessage: 'Status changed from Assessed to Open due to changes in the related account, account designation or inherent risk assessment. Re-assess the account grouping. When complete, {button}.',
	createComment: 'Créer un commentaire',
	editComment: 'Modifier le commentaire',
	commentTitle: 'Commentaire',
	createCommentInstructionalText: "Entrez les détails du commentaire pour le compte ou le risque sélectionné et cliquez sur « Enregistrer » pour terminer.",
	editCommentInstructionalText: "Modifiez les détails du commentaire pour le compte ou le risque sélectionné et cliquez sur « Enregistrer » pour terminer.",
	lastModified: 'Dernière modification',
	addComment: 'Ajouter un commentaire',
	accountDescription: 'Sélectionnez les comptes ouverts pour afficher les comptes de l’équipe principale qui n’ont pas été associés aux comptes de l’équipe affectée à l’audit de la composante et n’ont pas été marqués comme étant évalués. Sélectionnez les comptes évalués pour afficher les comptes de l’équipe principale qui ont été évalués.',
	riskDescription: 'Sélectionnez les risques ouverts pour afficher les risques de l’équipe principale qui n’ont pas été associés aux risques de l’équipe affectée à l’audit de la composante et n’ont pas été marqués comme étant évalués. Sélectionnez les risques évalués pour afficher les risques de l’équipe principale qui ont été évalués.',
	successAssessedMessage: 'The risk grouping has successfully been marked assessed. To review, click \'Assessed risks\' in the risk status tile.',
	successReOpenMessage: 'The risk grouping has successfully been re-opened. To view, click \'Open risks\' in the risk status tile.',

	// Relate risks modal
	relateRisksModalTitle: 'Relate component team risks',
	relateRisksModalInstructionalText: 'Select risk(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team risk.',
	primaryRegionTeamRisk: 'Primary Team risk:',
	primaryTeamRiskLabel: 'Risque de l’équipe principale',
	thereIsNoDataToDisplayForThisSelection: 'Aucune donnée à afficher pour cette sélection.',
	accountAndAsssociated: 'Account(s) and associated PSP index(es)',
	noAccountOrPspAssociated: 'There is not account or associated PSP index.',
	disabledRegionComponentTeamRiskLabel: "Ce risque de l’équipe affectée à l’audit de la composante est déjà mappé à un autre risque de l’équipe principale. Un risque de l’équipe affectée à l’audit de la composante ne peut être mappé qu’à un seul risque de l’équipe principale. Sélectionnez « Associer les risques » pour dissocier ce risque du risque de l’équipe principale en question, s’il y a lieu.",
	selectOneOrMore: 'Sélectionner un ou plusieurs risques',

	relateAccountsModalTitle: 'Relate component team accounts',
	relateAccountName: 'Primary Team account:',
	relateAccountpspIndexes: 'PSP index(es):',
	relateAccountInstructionalText: 'Select account(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team account.',
	pspIndexcountLabel: 'Références PCB associées au compte de l’équipe principale/zonale',
	relateAccounts: 'Associer les comptes',

	viewComponentTeamAccountsText: 'View component team accounts not related and/or not applicable',
	componentTeamAccountsModalTitle: 'Comptes de l’équipe affectée à l’audit de la composante non associés et/ou non applicables',
	componentTeamAccountsModalInstructionalText: "The list below displays the account(s) in the component team's EY Canvas engagement that are not related to a Primary Team account. Return to the component team reconciliation details screen to relate an account to a Primary Team account. Alternatively, if a component team account is not applicable to the group audit, mark as 'Not applicable'. <br/><br/> Marking an account 'Not applicable' will move the account to the 'Not applicable' tab. Accounts should be marked 'Not applicable' if they are not applicable to the group audit.",
	componentTeamAccountsModalNotApplicableInstructionalText: '\'Not applicable\' component team account(s) are marked this way because they are not applicable to the group audit. <br/><br/> If an account is listed below in error, select \'Undo not applicable\' to move the account to the \'Not related\' tab. Account(s) that are \'Not related\' should either be related to a Primary Team account in the Relate component team accounts modal or marked \'Not applicable\' if not applicable to the group audit.',
	notRelatedTab: 'Non associé',
	notApplicableTab: 'Non applicable',
	unmapped: 'Non mappé',
	unrelate: 'Dissocier',
	undoNotApplicable: 'Undo not applicable',
	action: 'Action',
	notApplicableActionTitletip: "Sélectionnez « Dissocier » pour déplacer le risque vers l’onglet « Non associé ». Un risque marqué comme étant « Non associé » doit être associé à un risque de l’équipe principale ou marqué comme étant « Non applicable » s’il ne s’applique pas à l’audit de groupe.",
	notRelatedActionTitletip: "Sélectionnez « Non applicable » pour déplacer le risque vers l’onglet « Non applicable ». Un risque de l’équipe affectée à l’audit de la composante marqué comme étant « Non applicable » ne s’applique pas à l’audit de groupe.",

	higherInheritRisk: 'Risque inhérent élevé',
	lowerInheritRisk: 'Risque inhérent faible',
	incompleteInheritRisk: 'Incomplete inherent risk',
	riskAssociated: 'Risque associé',
	riskAssociatedHigher: 'Risque associé contribuant au risque inhérent élevé',
	
	viewComponentTeamRisks: 'View component team risks not related and/or not applicable',
	unmappedRisksModalTitle: 'Risques de l’équipe affectée à l’audit de la composante marqués comme étant non associés et/ou non applicables',
	unmappedRisksModalInstructional: 'The list below displays the risk(s) in the component team\'s EY Canvas engagement that are not related to a Primary Team risk. Return to the component team reconciliation details screen to relate a risk to a Primary Team risk. Alternatively, if a component team risk is not applicable to the group audit, mark as \'Not applicable\'. <br/><br/> Marking a risk \'Not applicable\' will move the risk to the \'Not applicable\' tab. Risks should be marked \'Not applicable\' if they are not applicable to the group audit.',
	notApplicableRisksModalInstructional: "'Not applicable' component team risk(s) are marked this way because they are not applicable to the group audit. <br/><br/> If a risk is listed below in error, select 'Undo not applicable' to move the risk to the 'Not related' tab. Risk(s) that are 'Not related' should either be related to a Primary Team risk in the Relate component team risks modal or marked 'Not applicable' if not applicable to the group audit.",
	added: 'Ajouté',

	groupRiskAssessmentInstructional: "The Group risk assessment Reconciliation allows the Primary Team to view the accounts and risks of material misstatement created in the component team's EY Canvas engagement.<br><br>Click on a component name below to open the component reconciliation screen where the Primary Team can relate the accounts and risks of material misstatement that were related to the component in the Primary Team's EY Canvas engagement to the accounts and risks of material misstatement that exist in the component team's EY Canvas engagement.<br><br>The Reconciliation can assist the Primary Team to identify any deviations from the group risk assessment information communicated in the group instructions, such as differences in accounts, account designations, relevant assertions, inherent risk assessments, and identified risks of material misstatement and help facilitate group involvement discussions with component teams.",
	groupRiskAssessmentActivityFeedInstructional: "The Activity feed allows the Primary Team to view any changes to the risk assessment made by the component teams in their local EY Canvas engagement. Activities highlighted include changes made in the underlying component EY Canvas engagement to accounts, account designations, assertions and identified risks of material misstatements since the creation of the EY Canvas Oversight project. This is not reflecting activity in the Reconciliation.",
	disclaimerInstructional: 'The EY Canvas Oversight Group risk assessment functionality can support effective project management by a Primary Team in a group audit. However, this functionality is not intended to provide, document or generate audit evidence. Further, it is not intended to replace the Primary Team\'s involvement in the component team\'s work, including review of component teams reporting deliverables. We do not include screenshots or data exported from EY Canvas Oversight in the Primary Team\'s EY Canvas as evidence of the Primary Team\'s involvement in, or supervision of, the work of component teams.'
};

export const temporaryLabels = {
	dryDock: 'Drydock',
	darkMode: 'Mode sombre',
	dashboard: 'Tableau de bord',
	projects: 'Projets',
	scopeStrategy: 'Étendue et stratégie',
	accountSummary: 'Synthèse des comptes',
	scotSummary: 'Synthèse des catégories d’opérations importantes',
	craSummary: 'Synthèse de l’EGR',
	itSummary: 'Synthèse TI',
	SPSummary: 'Synthèse de l’évaluation des procédures de corroboration',
	auditPlan: 'Plan de mission',
	conclusion: 'Conclusion',
	findings: 'Constatations',
	changesReport: 'Changements après la date du rapport.',
	teamMember: 'Indépendance des membres de l’équipe',
	archiveChecklist: 'Liste de contrôle de l’archivage',
	enagagementmanagement: 'Gestion de la mission',
	integration: 'Intégration',
	guidedWorkflow: 'Flux de travail guidé',
	copyrightMessage: '© <année>. Tous droits réservés.'
};

export const createGRAProjectLabels = {
	creationInstructional: "Entrez un nom de projet et sélectionnez une mission EY Canvas de l’équipe principale ou de l’équipe zonale à partir de la liste ci-après pour créer un projet dans le module Surveillance d’EY Canvas. <br> Selon la mission sélectionnée, les missions EY Canvas identifiées dans la structure de l’audit de groupe dans EY Canvas seront automatiquement intégrées dans la configuration de ce projet. Cliquez sur le {link} pour plus d’information sur le module Surveillance d’EY Canvas.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: 'Rechercher le nom ou l’identifiant d’une mission EY Canvas ou le nom d’un client',
	noAccessToEng: 'Vous n’avez accès à aucune mission EY Canvas.',
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: 'Sélectionner au moins une mission à enregistrer.',
	userGuideLinkText: 'Guide d’utilisation'
};

export const deleteCommentModalLabels ={
	titleText: 'Supprimer le commentaire',
	instructionalText: 'Voulez-vous vraiment supprimer le commentaire?',
	triggerText: 'Supprimer',
	confirmLabel: 'Confirmer',
	cancelLabel: 'Annuler',
	closeLabel: 'Fermer',
}

export const gaRoleType = [{
		id: GARoleTypeId.Primary,
		label: 'Principale'
	},
	{
		id: GARoleTypeId.Region,
		label: 'Zone'
	},
	{
		id: GARoleTypeId.Component,
		label: 'Composante'
	}
];

export const engagementTableLabels = {
	engagementName: 'Nom de la mission',
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: 'Date de création du projet',
	GAComponentCreated: 'Composante ajoutée',
	GAComponentRemoved: 'Composante retirée',
	GAComponentUnlinked: 'Composante dissociée',
	AccountAdded: 'Compte ajouté',
	AccountRemoved: 'Compte retiré',
	AccountDesignationChanged: 'Désignation du compte modifiée',
	AccountEstimateChanged: 'Estimation comptable modifiée',
	AccountExecutionTypeChanged: 'Type d’exécution du compte modifiée',
	AssertionAssociated: 'Assertion associée',
	AssertionUnassociated: 'Assertion non associée',
	AssertionInherentRiskChanged: 'Modification apportée au risque inhérent',
	AssertionControlRiskDesignationChanged: 'Modification apportée à la désignation du risque lié au contrôle',
	RiskCreated: 'Risque créé',
	RiskRemoved: 'Risque retiré',
	RiskAssociated: 'Risque associé',
	RiskUnassociated: 'Risque non associé'
};

export const activityTableLabels = {
	sourceEngagement: 'Mission source',
	activityType: 'Type d’activité',
	objectImpacted: 'Objet touché',
	relatedObjectImpacted: 'Objet associé touché',
	relatedSecondaryObjectImpacted: 'Objet secondaire associé touché',
	activityDate: 'Date de l’activité'
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: 'Component team risk name and risk designation',
	details: 'Détails'
};

export const riskTypes = [{
		id: '1',
		label: 'Risque important'
	},
	{
		id: '2',
		label: 'Risque de fraude'
	},
	{
		id: '3',
		label: 'Risque inhérent'
	}
];

export const engagementLabels = {
	accountName: 'Nom du compte / de l’information à fournir',
	accountTypeName: 'Désignation',
	canvasEngagementId: 'Identifiant de la mission',
	controlRiskTypeName: 'Risque lié au contrôle',
	engagementDescription: 'Nom de la mission',
	inherentRiskTypeName: 'Risque inhérent',
	assertionName: 'Assertion',
	pspIndexTitle: 'Référence PCB',
	riskName: 'Nom du risque',
	riskTypeName: 'Type de risque',
	relatedTasks: 'Tâches associées',
	taskStatus: 'État de la tâche',
	controlRiskAssessment: 'Évaluation du risque lié au contrôle'
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
	groupRiskAssessmentInstructional: labels.groupRiskAssessmentInstructional,
	groupRiskAssessmentActivityFeedInstructional: labels.groupRiskAssessmentActivityFeedInstructional,
	disclaimerInstructional: labels.disclaimerInstructional
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: 'Aucune donnée à afficher pour ce tableau.',
	unselectedEntities: 'Il n’y a aucune donnée de rapprochement pour ce projet du module Surveillance d’EY Canvas. Associez les composantes aux comptes dans le flux des instructions pour l’audit de groupe de la mission EY Canvas de l’équipe principale pour que les données de rapprochement s’affichent ici.',
	columns: {
		components: 'Composantes',
		open: 'Ouvrir',
		assessed: 'Évalués',
		total: 'Total'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: 'Compte de l’équipe affectée à l’audit de la composante',
		pspIndexes: 'Référence(s) PCB'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "Ce compte de l’équipe affectée à l’audit de la composante est déjà mappé à un autre compte de l’équipe principale. Un compte de l’équipe affectée à l’audit de la composante ne peut être mappé qu’à un seul compte de l’équipe principale. Sélectionnez « Associer les comptes » pour dissocier ce compte du compte de l’équipe principale en question, s'il y a lieu."
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: 'Référence(s) PCB',
		notRelated: {
			actionColumnName: labels.action,
			titleTip: 'Marquer un compte comme étant « Non applicable » pour déplacer le compte dans l’onglet « Non applicable ». Les comptes doivent être marqués comme étant non applicables s’ils ne s’appliquent pas à l’audit de groupe.',
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: 'Sélectionnez « Dissocier » pour déplacer le compte vers l’onglet « Non associé ». Un compte marqué comme étant « Non associé » doit être associé à un compte de l’équipe principale ou marqué comme étant « Non applicable » s’il ne s’applique pas à l’audit de groupe.',
			actionLabel: labels.undoNotApplicable
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "Risque de l’équipe affectée à l’audit de la composante",
	actions: "Action"
};

export const AdminUserErrors = {
	userError: 'Utilisateur introuvable.'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "Vous ne disposez pas des autorisations requises pour effectuer cette action."
};

export const Errors = {
	106: "Vous ne disposez pas des autorisations requises pour effectuer cette action.",
	107: "Vous ne disposez pas des autorisations requises pour effectuer cette action.",
	111: 'Vous ne pouvez pas vous attribuer des droits d’accès.',
	112: 'Utilisateur introuvable.',
	117: 'You cannot delegate access to an external user.',
	310: 'Projet introuvable.',
	314: 'Le domaine pour un ou plusieurs des administrateurs du groupe n’est pas autorisé pour ce groupe.',
	316: 'Vous devez être propriétaire du projet ou administrateur du groupe pour ajouter des membres à l’équipe. Communiquez avec un des propriétaires du projet pour obtenir l’accès.',
	317: 'Seuls les membres internes peuvent être ajoutés en tant que propriétaires du projet. Voici les utilisateurs externes : {0}. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	318: 'Le domaine pour {0} n’est pas autorisé pour le groupe suivant : {1}',
	319: 'Le projet a été terminé par un autre propriétaire du projet. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.',
	321: 'Vous devez être propriétaire du projet effectuer cette opération. Communiquez avec un des propriétaires du projet pour obtenir l’accès.',
	323: 'Ce groupe a été supprimé par un autre membre de l’équipe. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.',
	324: 'Vous devez être propriétaire du projet pour le terminer. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.',
	325: 'Vous devez être propriétaire du projet ou administrateur du groupe pour effectuer ces modifications. Communiquez avec un des propriétaires du projet pour obtenir l’accès.',
	326: 'Remplir tous les champs requis pour enregistrer ce projet. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.',
	327: 'Ce projet a déjà été enregistré.',
	328: 'Le membre de l’équipe que vous essayez d’ajouter est déjà un membre de ce groupe. Veuillez actualiser la page et réessayer.',
	330: 'L’ancien propriétaire du projet ne peut pas être supprimé',
	331: 'Un ou plusieurs groupes ont été supprimés par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si l’erreur persiste, communiquez avec le Service de dépannage.',
	332: 'Au moins un propriétaire de projet est requis. Vous ne pouvez pas vous retirer de ce projet.',
	341: 'Vous n’avez pas accès aux missions ou aux clients sélectionnés.',
	343: 'Vous pouvez uniquement supprimer les projets actifs ou les ébauches de projet.  Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	344: 'Vous devez être propriétaire du projet pour le supprimer. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	345: 'Ce projet a été supprimé par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	346: 'L’accès pour {0} a déjà été passé en revue par un autre propriétaire du projet ou administrateur de l’entité. Veuillez actualiser le journal des accès et réessayer.',
	347: 'Vous devez être propriétaire du projet ou administrateur de l’entité pour ajouter ou supprimer des contacts pour ce projet. Communiquez avec un propriétaire du projet pour demander accès.',
	348: 'Vous ne pouvez supprimer que les contacts d’entités pour lesquelles vous êtes administrateur. Les contacts suivants appartiennent à des entités pour lesquelles vous n’êtes pas administrateur et vous ne pouvez pas les supprimer : {0}.',
	360: 'Vous devez être propriétaire du projet pour effectuer cette action.',
	361: 'Vous devez être propriétaire de projet ou administrateur de l’entité pour effectuer cette action. Communiquez avec un propriétaire de projet pour demander l’accès.',
	362: 'Vous ne pouvez gérer l’accès que des contacts qui appartiennent aux entités pour lesquelles vous êtes administrateur. Les contacts suivants appartiennent à des entités pour lesquelles vous n’êtes pas administrateur et leur accès ne peut pas être modifié : {0}.',
	364: 'Vous essayez de modifier l’accès pour un ou plusieurs contacts qui ont été retirés de ce projet. Veuillez actualiser la page et réessayer.',
	365: 'Vous essayez de modifier les attributs pour un ou plusieurs contacts qui ont été retirés de ce projet : {0}. Veuillez actualiser la page et réessayer.',
	366: 'Vous ne pouvez modifier les attributs que des contacts qui appartiennent aux entités pour lesquelles vous êtes administrateur. Les contacts suivants appartiennent à des entités pour lesquelles vous n’êtes pas administrateur : {0}.',
	367: 'La colonne personnalisée que vous essayez de modifier a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.',
	368: 'La colonne ou l’option personnalisée que vous essayez de modifier a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.',
	369: 'Vous devez être propriétaire de projet pour effectuer cette action.',
	370: "Vous ne pouvez modifier les attributs que des contacts qui appartiennent aux entités pour lesquelles vous êtes l'administrateur. Les contacts suivants appartiennent à des entités dont vous n’êtes pas l'administrateur : {0}.",
	372: 'Vous devez être propriétaire de projet pour effectuer cette action.',
	373: 'Vous ne pouvez pas supprimer le propriétaire du projet de la liste des contacts. Accédez à l’Assistant Projet pour effectuer l’action demandée.',
	374: 'Vous ne pouvez pas vous retirer de ce projet, car vous en êtes le propriétaire.',
	375: 'Vous ne pouvez pas supprimer le dernier propriétaire d’un projet. Il doit rester au moins un propriétaire de projet.',
	376: 'Vous devez être propriétaire du projet pour ajouter ou supprimer un propriétaire de projet ou un administrateur de l’entité pour ce projet. Les contacts suivants ne peuvent pas être supprimés : {0}',
	378: 'Le domaine ne peut pas être supprimé, car il est utilisé par un contact dont le nom figure sur la liste des contacts de ce projet de surveillance. Accédez à la liste des contacts et supprimez le ou les contacts associés à ce domaine, puis revenez ici pour supprimer le domaine.',
	502: 'Échec de l’appel de récupération des missions. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	503: 'Vous n’avez pas accès aux clients sélectionnés.',
	601: 'Échec de l’appel de récupération de clients. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',
	1605: 'L’utilisateur sélectionné existe déjà.',

	1803: 'Balisage effectué avec des données du projet invalides. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage pour obtenir de l’aide.',
	1804: 'Vous devez être propriétaire du projet pour effectuer le balisage.',
	1901: "Échec de l’appel de l'interface de programmation pour l’envoi du message",
	1902: 'Le message ne peut pas être vide.',
	1903: 'La longueur autorisée pour le message est de 200 caractères.',
	1904: 'La longueur autorisée pour le texte de la fonction de rappel est de 50 caractères.',
	1905: 'La longueur autorisée pour l’URI de la fonction de rappel est de 50 caractères.',
	1906: 'Vous devez sélectionner au moins un filtre pour continuer.',
	1907: "Un destinataire ne peut être ajouté qu'une seule fois.",
	1908: 'Le champ de la mission ne peut pas être vide.',
	1909: 'La valeur du type de message n’est pas valide.',
	1910: 'La valeur du destinataire ne peut pas être vide.',
	1911: 'Le message toast ne peut pas être vide.',
	1912: 'La valeur du type de destinataire n’est pas valide.',
	1913: 'Vous ne disposez pas des droits d’accès appropriés pour envoyer une notification. Communiquez avec un propriétaire des projets ou un administrateur de l’entité pour obtenir l’accès.',
	1914: 'Les notifications ne peuvent être envoyées qu’à des contacts internes. Veuillez vérifier la liste des destinataires et retirer les contacts externes pour continuer.',
	2101: 'Le service de rédaction des directives d’EY, d’approbation et de notification n’est pas disponible pour le moment. Nous ne sommes pas en mesure de confirmer si toutes les directives pertinentes sont prêtes. Si vous n’avez pas revu les directives pertinentes, actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.',

	// Reconciliation
	2701: 'Get All Reconciliations call failed.',
	2702: 'Demande invalide.',
	2703: 'Get by Id Reconciliations call failed.',
	2704: 'Get by Id Risks call failed.',
	2705: 'Projet introuvable dans la base de données.',
	2706: 'Compte introuvable dans la base de données.',
	2707: 'Mission introuvable dans la base de données.',
	2708: 'Create comment call failed.',
	2709: 'Un commentaire a déjà été créé. Veuillez actualiser la page et réessayer.',
	2710: 'Patch group component account call failed.',
	2711: 'Le compte de la composante du groupe est introuvable dans la base de données.',
	2712: 'Le commentaire de la justification ne peut pas être vide.',
	2713: 'Le commentaire de la justification ne peut pas dépasser 4 000 caractères.',
	2714: 'Risque de la composante du groupe introuvable.',
	2715: 'Composante du groupe introuvable.',
	2716: 'Risk was not found.',
	2717: 'Invalid group risk status value.',
	2718: 'Update Reconciliation call failed.',
	2719: 'Patch group component risk comment call failed. Refresh the page and try again.',
	2720: 'Cet élément a été modifié ou supprimé par un autre utilisateur. Veuillez actualiser la page et réessayer.',
	2721: 'Un commentaire a déjà été créé. Veuillez actualiser la page et réessayer.',
	2722: 'Account is deleted.'
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: 'Connecter au moins une mission à l’organigramme pour continuer.',
	ErrorAtleastOneGroupAssociationRequired: 'Connecter au moins un groupe à l’organigramme pour continuer.',
	ErrorStep2DataNotComplete: 'Entrer le nom de chaque entité dans l’organigramme pour continuer.'
};

export const engagementsViewBy = [{
		id: 0,
		label: 'Tout',
		value: 'Toutes'
	},
	{
		id: 1,
		label: 'Par pays',
		value: 'Pays',
		groupAttributeName: 'countryName'
	},
	{
		id: 2,
		label: 'Par bureau principal',
		value: 'Par région',
		groupAttributeName: 'regionName'
	},
	{
		id: 3,
		label: 'Par type de mission',
		value: 'Type',
		groupAttributeName: 'profileNature'
	}
];

export const milestones = [{
		id: 1,
		label: 'Étendue',
		auditPhaseId: 1,
		value: 1
	},
	{
		id: 2,
		label: 'Stratégie',
		auditPhaseId: 1,
		value: 2
	},
	{
		id: 3,
		label: 'Tests de cheminement',
		auditPhaseId: 2,
		value: 3
	},
	{
		id: 4,
		label: 'Tests des contrôles intermédiaires',
		auditPhaseId: 2,
		value: 4
	},
	{
		id: 5,
		label: 'Tests de corroboration intermédiaires',
		auditPhaseId: 2,
		value: 5
	},
	{
		id: 6,
		label: 'Tests de cheminement (processus de fin d’exercice)',
		auditPhaseId: 2,
		value: 6
	},
	{
		id: 7,
		label: 'Tests des contrôles de fin d’exercice',
		auditPhaseId: 2,
		value: 7
	},
	{
		id: 8,
		label: 'Tests de corroboration de fin d’exercice',
		auditPhaseId: 2,
		value: 8
	},
	{
		id: 9,
		label: 'Conclusion',
		auditPhaseId: 3,
		value: 9
	},
	{
		id: 10,
		label: 'S. O.',
		auditPhaseId: 2,
		value: 10
	},
	{
		id: 11,
		label: 'Exécution',
		auditPhaseId: 2,
		value: 11
	},
	{
		id: 12,
		label: 'Activités liées à la qualité de l’étape Étendue et stratégie',
		auditPhaseId: 1,
		value: 12
	},
	{
		id: 13,
		label: 'Autres activités de l’étape Étendue et stratégie',
		auditPhaseId: 1,
		value: 13
	},
	{
		id: 14,
		label: 'EGR',
		auditPhaseId: 1,
		value: 14
	},
	{
		id: 15,
		label: 'Évaluation des risques et caractère significatif',
		auditPhaseId: 1,
		value: 15
	},
	{
		id: 16,
		label: 'Finaliser l’étape Étendue et stratégie',
		auditPhaseId: 1,
		value: 16
	},
	{
		id: 17,
		label: 'Activités de gestion de projet post-intermédiaires',
		auditPhaseId: 2,
		value: 17
	}
];

export const daysOptions = [{
		id: daySelection.tomorrow,
		value: daySelection.tomorrow,
		label: 'Demain'
	},
	{
		id: daySelection.next3days,
		value: daySelection.next3days,
		label: 'Dans les 3 prochains jours'
	},
	{
		id: daySelection.next5days,
		value: daySelection.next5days,
		label: 'Dans les 5 prochains jours'
	},
	{
		id: daySelection.next10days,
		value: daySelection.next10days,
		label: 'Dans les 10 prochains jours'
	},
	{
		id: daySelection.next30days,
		value: daySelection.next30days,
		label: 'Dans les 10 prochains jours'
	}
];

export const auditPhases = [{
		id: 1,
		label: 'Étendue et stratégie'
	},
	{
		id: 2,
		label: 'Exécution'
	},
	{
		id: 3,
		label: 'Conclusion'
	}
];

export const findings = [{
		id: 1,
		label: 'Anomalies',
		subTitle: 'Anomalies par type'
	},
	{
		id: 2,
		label: 'Déficiences',
		subTitle: 'Déficiences par gravité'
	}
];
export const risks = [{id: 1, label: '', subTitle: 'By type'}];

export const auditStrategies = [{
		id: 1,
		label: 'Corroboration',
		subTitle: 'Procédures de corroboration par type'
	},
	{
		id: 2,
		label: 'Contrôles',
		subTitle: 'Contrôles par stratégie de tests des contrôles'
	},
	{
		id: 3,
		label: 'TI',
		subTitle: 'Procédures liées aux TI par stratégie de test'
	}
];

export const auditInsights = [{
		id: 1,
		label: 'Par rôle dans le groupe'
	},
	{
		id: 2,
		label: 'Tout'
	}
];

export const projectStatus = {
	Active: 'en cours',
	Draft: 'ébauche',
	Cancel: 'annuler',
	Complete: 'fait',
	Delete: 'supprimer'
};

export const ProjectStatusLabels = [{
		label: 'Initial',
		id: 1,
		value: 'Initial'
	},
	{
		label: 'Projet',
		id: 2,
		value: 'Draft'
	},
	{
		label: 'Actif',
		id: 3,
		value: 'Active'
	},
	{
		label: 'Annulé',
		id: 4,
		value: 'Cancelled'
	},
	{
		label: 'Terminé',
		id: 5,
		value: 'Completed'
	},
	{
		label: 'Supprimée',
		id: 6,
		value: 'Delete'
	}
];

export const projectTeamEngagementTableGroup = [{
		id: 1,
		label: 'Affectations du préparateur'
	},
	{
		id: 2,
		label: 'Affectations du responsable de la revue'
	}
];

export const archiveReportQualifiedType = [{
		id: archiveReportQualifiedTypeId.notSelected,
		label: 'Non sélectionné'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
		label: 'Sans réserve – avec paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
		label: 'Sans réserve – sans paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
		label: 'Avec réserve – avec paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
		label: 'Avec réserve – sans paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
		label: 'Opinion défavorable – avec paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
		label: 'Opinion défavorable – sans paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
		label: 'Impossibilité d’exprimer une opinion – avec paragraphe d’observations'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
		label: 'Impossibilité d’exprimer une opinion – sans paragraphe d’observations'
	}
];

export const strategyTableGroup = [{id: 1, label: ''}];

export const roleForMember = [{
		id: roles.partnerInCharge,
		label: 'Associé responsable',
		roleAbbreviation: 'PTR IN CHG'
	},
	{
		id: roles.engagementPartner,
		label: 'Associé responsable de la mission',
		roleAbbreviation: 'EP'
	},
	{
		id: roles.executiveDirector,
		label: 'Associé délégué',
		roleAbbreviation: 'EXEC DIR'
	},
	{
		id: roles.principal,
		label: 'Principal',
		roleAbbreviation: 'PRINCIPAL'
	},
	{
		id: roles.seniorManager,
		label: 'Chef d’équipe senior',
		roleAbbreviation: 'SR.MANAGER'
	},
	{
		id: roles.manager,
		label: 'Chef d’équipe',
		roleAbbreviation: 'MANAGER'
	},
	{
		id: roles.senior,
		label: 'Professionnel senior',
		roleAbbreviation: 'SENIOR'
	},
	{
		id: roles.staff,
		label: 'Professionnel junior',
		roleAbbreviation: 'STAFF'
	},
	{
		id: roles.intern,
		label: 'Stagiaire',
		roleAbbreviation: 'Intrn'
	},
	{
		id: roles.engagementQualityReviewer,
		label: 'Responsable du contrôle qualité de la mission',
		roleAbbreviation: 'EQR'
	},
	{
		id: roles.otherPartner,
		label: 'Autre associé',
		roleAbbreviation: 'OTHER PTR'
	},
	{
		id: roles.gdsStaff,
		label: 'Groupe PSM – Stagiaire',
		roleAbbreviation: 'GDS-STAFF'
	},
	{
		id: roles.advisory,
		label: 'Consultation (groupe Risque et certification en TI, SCT, Capital humain ou autre)',
		roleAbbreviation: 'ADV'
	},
	{
		id: roles.tax,
		label: 'Fiscalité',
		roleAbbreviation: 'Fiscalité'
	},
	{
		id: roles.executiveSupportServices,
		label: 'Services de soutien aux cadres',
		roleAbbreviation: 'ESS'
	},
	{
		id: roles.generalCounsel,
		label: 'Affaires juridiques',
		roleAbbreviation: 'GCO'
	},
	{
		id: roles.auditQualityReviewer,
		label: 'Responsable du contrôle qualité de l’audit',
		roleAbbreviation: 'AQR'
	},
	{
		id: roles.mlComponentTeam,
		label: 'Équipe affectée à l’audit d’une composante pour les entités à établissements multiples',
		roleAbbreviation: 'MCT'
	},
	{
		id: roles.clientSupervisor,
		label: 'Superviseur du client',
		roleAbbreviation: 'ClntS'
	},
	{
		id: roles.clientStaff,
		label: 'Personnel du client',
		roleAbbreviation: 'ClntSt'
	},
	{
		id: roles.internalAuditSupervisor,
		label: 'Superviseur de la fonction d’audit interne',
		roleAbbreviation: 'IASup'
	},
	{
		id: roles.internalAuditStaff,
		label: 'Personnel de la fonction d’audit interne',
		roleAbbreviation: 'IASt'
	},
	{
		id: roles.regulator,
		label: 'Autorité de réglementation',
		roleAbbreviation: 'Reglr'
	},
	{
		id: roles.other,
		label: 'Autre (p. ex., revue de contrôle préalable)',
		roleAbbreviation: 'Otrs'
	},
	{
		id: roles.office,
		label: 'Bureau',
		roleAbbreviation: 'Off'
	},
	{
		id: roles.area,
		label: 'Région',
		roleAbbreviation: 'Area'
	},
	{
		id: roles.industry,
		label: 'Secteur d’activité',
		roleAbbreviation: 'IND'
	},
	{
		id: roles.national,
		label: 'National',
		roleAbbreviation: 'NAT'
	},
	{
		id: roles.global,
		label: 'Global',
		roleAbbreviation: 'GBL'
	},
	{
		id: roles.gsdSenior,
		label: 'Groupe PSM – Professionnel senior',
		roleAbbreviation: 'GDS-SENIOR'
	},
	{
		id: roles.gsdManager,
		label: 'Groupe PSM – Chef d’équipe',
		roleAbbreviation: 'GDS-MANAGER'
	}
];

export const toggleCCPEntityOptions = [{
		id: toggleCCPEntityDetail.comingDue,
		label: labels.comingDue
	},
	{
		id: toggleCCPEntityDetail.overdue,
		label: labels.taskStatusOverdue
	},
	{
		id: toggleCCPEntityDetail.returned,
		label: labels.returned
	}
];

export const reportReadinessSeries = [
	{id: readinessReportCategories.comingDueOver2Weeks, label: `> 2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.overDueOver2Weeks, label: `> 2{break}${labels.weeks}`}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: 'Audit des états financiers',
	[natureOfEngagements.integratedStatements.id]: 'Audit intégré des états financiers et du contrôle interne à l’égard de l’information financière',
	[natureOfEngagements.reviewStatements.id]: 'Examen des états financiers intermédiaires',
	[natureOfEngagements.nonAuditAccount.id]: 'Mission autre que d’audit avec fonctionnalité compte/assertion/catégorie d’opérations importante',
	[natureOfEngagements.nonAuditWorkPlan.id]: 'Mission autre que d’audit avec la fonctionnalité plan de travail seulement'
};

export const AdminRoles = [{
		label: 'Admin-lecture de l’application',
		id: 1
	},
	{
		label: 'Admin-écriture de l’application',
		id: 2
	},
	{
		label: 'Super-admin de l’application',
		id: 3
	}
];

export const userType = [{
		value: 1,
		label: 'Interne'
	},
	{
		value: 2,
		label: 'Externe'
	}
];

export const MessageType = [{
		value: 1,
		label: 'Adresse courriel'
	},
	{
		value: 2,
		label: 'Notification'
	}
];

export const groupRole = [{
		value: 1,
		label: 'Équipe principale',
		id: 1,
		selected: false,
		disabled: false
	},
	{
		value: 2,
		label: 'Équipe zonale',
		id: 2,
		selected: false,
		disabled: false
	},
	{
		value: 3,
		label: 'Équipe affectée à l’audit de la composante',
		id: 3,
		selected: false,
		disabled: false
	},
	{
		value: 4,
		label: 'Équipe affectée à l’audit d’une composante faisant rapport à un autre cabinet d’audit qu’EY',
		id: 4,
		selected: false,
		disabled: false
	},
	{
		value: 5,
		label: 'Sans objet',
		id: 5,
		selected: false,
		disabled: false
	}
];

export const accessLogResource = [{
		id: 1,
		label: 'Contacts à ajouter'
	},
	{
		id: 2,
		label: 'Contacts à retirer'
	}
];

export const addContactsTabsResource = [{
		id: 1,
		label: 'Accès'
	},
	{
		id: 2,
		label: 'Attributs'
	},
	{
		id: 3,
		label: 'Balises'
	}
];

export const tags = [{
		name: 'Associé de l’audit',
		id: 'auditPartner'
	},
	{
		name: 'Chef d’équipe de la mission d’audit',
		id: 'auditEngagementManager'
	},
	{
		name: 'Chef d’équipe de la mission, Groupe PSM',
		id: 'gdsEngagementManager'
	},
	{
		name: 'Associé, Fiscalité',
		id: 'taxPartner'
	},
	{
		name: 'Chef d’équipe de la mission, Fiscalité',
		id: 'taxEngagementManager'
	},
	{
		name: 'Associé, TI pour les audits comptables',
		id: 'faitPartner'
	},
	{
		name: 'Chef d’équipe de la mission, TI pour les audits comptables',
		id: 'faitEngagementManager'
	},
	{
		name: 'Associé, Consultation',
		id: 'advisoryPartner'
	},
	{
		name: 'Chef d’équipe de la mission, Consultation',
		id: 'advisoryEngagementManager'
	},
	{
		name: 'Spécialiste',
		id: 'specialist'
	},
	{
		name: 'Administrateur du client',
		id: 'clientadministrator'
	}
];

export const dashboardContactViews = [{
		id: dashboardTabId.milestones,
		value: dashboardViewsConstants.milestones,
		tooltipText: 'Progression de la mission par jalon',
		key: 'Jalons',
		checked: false
	},
	{
		id: dashboardTabId.projectManagement,
		value: dashboardViewsConstants.projectManagement,
		tooltipText: 'État des notes de revue et des affectations, y compris les éléments en retard. Les droits d’accès au tableau de bord Gestion du projet ne peuvent pas être accordés à des utilisateurs externes.',
		key: 'Gestion de projet',
		checked: false
	},
	{
		id: dashboardTabId.groupAudit,
		value: dashboardViewsConstants.groupAudit,
		tooltipText: 'État pour l’équipe principale et l’équipe affectée à l’audit de la composante, y compris les éléments retournés et en retard.',
		key: 'Audit de groupe',
		checked: false
	},
	{
		id: dashboardTabId.groupRiskAssessment,
		value: dashboardViewsConstants.groupRiskAssessment,
		tooltipText: 'Vue de l’évaluation des risques à l’échelle du groupe dans les équipes principales et les équipes affectées à l’audit de composantes. Les clients n’auront pas accès à cette vue.',
		key: 'Évaluation des risques à l’échelle du groupe',
		checked: false
	},
	{
		id: dashboardTabId.canvasClientPortal,
		value: dashboardViewsConstants.ccp,
		tooltipText: 'État de la demande, y compris les éléments venant à échéance, en retard et retournés',
		key: 'Portail client d’EY Canvas',
		checked: false
	},
	{
		id: dashboardTabId.insights,
		value: dashboardViewsConstants.insights,
		tooltipText: 'Comparaison des risques, des procédures de corroboration, de la stratégie axée sur les contrôles et des constatations entre l’équipe principale et les équipes affectées à l’audit des composantes. Les droits d’accès au tableau de bord Perspectives ne peuvent pas être accordés à des utilisateurs externes.',
		key: 'Informations',
		checked: false
	},
	{
		id: dashboardTabId.reporting,
		value: dashboardViewsConstants.reporting,
		tooltipText: 'Degré de préparation du rapport, modifications et état d’achèvement des tâches par pays.',
		key: 'Rapport',
		checked: false
	}
];

export const colorOptionsLabels = {
	red: 'Rouge',
	orange: 'Orange',
	teal: 'Sarcelle',
	blue: 'Bleu',
	purple: 'Violet',
	green: 'Vert',
	yellow: 'Jaune',
	gray: 'Gris'
};

export const exportToExcelLabels = {
	yes: 'Oui',
	no: 'Non',
	exportData: labels.exportData,
	exportButtonTitle: 'Cliquer ici pour télécharger les informations détaillées de la demande au client pour les entités sélectionnées dans l’organigramme situé dans le volet de gauche de ce projet du module Surveillance d’EY Canvas.',
	projectInfo: 'Renseignements sur le projet',
	exportDate: 'Date de l’exportation',
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: 'Numéro de l’élément de la demande',
	requestTitle: 'Titre de la demande',
	priority: 'Priorité',
	status: labels.status,
	receivedDate: 'Date de réception',
	dueDate: 'Date d’échéance',
	overdue: labels.overdueLabel,
	eyContact: 'Personne-ressource chez EY',
	assignedTo: 'Attribué à',
	statusLabels: [{
			id: 1,
			label: 'Projet'
		},
		{
			id: 2,
			label: 'Aucun client'
		},
		{
			id: 3,
			label: 'Envoyée'
		},
		{
			id: 4,
			label: 'Erreur système'
		},
		{
			id: 5,
			label: 'Client invalide'
		},
		{
			id: 6,
			label: 'En attente d’une réponse'
		},
		{
			id: 7,
			label: 'Reçue'
		},
		{
			id: 8,
			label: 'Acceptée'
		},
		{
			id: 9,
			label: 'Retournée'
		},
		{
			id: 10,
			label: 'Retirée'
		},
		{
			id: 11,
			label: 'Envoi en cours'
		},
		{
			id: 12,
			label: 'Acceptation en cours'
		},
		{
			id: 13,
			label: 'Retrait en cours'
		},
		{
			id: 14,
			label: 'Suppression en cours'
		},
		{
			id: 15,
			label: 'Retour en cours'
		},
		{
			id: 16,
			label: 'Réponse en cours'
		},
		{
			id: 17,
			label: 'Supprimée'
		},
		{
			id: 18,
			label: 'Client invalide retourné'
		},
		{
			id: 19,
			label: 'Rappel en cours'
		},
		{
			id: 20,
			label: 'Rappelée'
		},
		{
			id: 21,
			label: 'Traitement en cours'
		},
		{
			id: 22,
			label: 'Rappel en cours'
		}
	],
	priorityTypeLabels: [{
			id: 1,
			label: 'Faible'
		},
		{
			id: 2,
			label: 'Modérée'
		},
		{
			id: 3,
			label: 'Élevée'
		},
		{
			id: 4,
			label: 'Critique'
		}
	],

	risks: {
		exportButtonTitle: 'Cliquez ici pour télécharger des données détaillées sur l’évaluation des risques pour les entités sélectionnées dans l’organigramme du volet de gauche de ce projet du module Surveillance d’EY Canvas.',
		tabTitle: 'Informations sur l’évaluation des risques',
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: 'Nom du compte / de l’information à fournir',
			pspIndex: 'Référence PCB',
			accountType: 'Désignation',
			assertion: 'Assertion',
			inherentRisk: 'Risque inhérent',
			controlRisk: 'Risque lié au contrôle',
			craValue: 'Évaluation du risque lié au contrôle',
			riskType: 'Type de risque',
			riskName: 'Nom du risque',
			relatedTasks: 'Tâches associées',
			taskStatus: 'État de la tâche'
		}
	},
	exportButtonTooltip: 'Cliquez ici pour télécharger les données de rapprochement détaillées pour l’équipe principale et l’équipe affectée à l’audit de la composante associée.',
	primaryTeamEngagementName: 'Nom de la mission de l’équipe principale',
	componentTeamEngagementName: 'Nom de la mission de l’équipe affectée à l’audit de la composante',
	howToUseThisExport: 'Utilisation des données exportées :',
	howToUseThisExportText: 'The information in the "Accounts" and "Risks" tabs of this excel file summarizes the ​reconciliation of the accounts and risks included in the Primary Team group risk assessment communication to the accounts and risks existing in the component EY Canvas engagement.\n On the "Accounts" tab, we are displaying the list of relevant Primary and component team accounts. In addition, we are displaying the details of each Primary and component team account, including account name, associated PSP index(es), account designation and the associated assertions. If Primary and component team account(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team account(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.\n On the "Risks" tab, we are displaying the list of relevant Primary and component team risks. In addition, we are displaying the details of each Primary and component team risk, including risk name, risk designation, accounts related to the risks and the associated PSP index(es) to the accounts. If Primary and component team risk(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team risk(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.',
	reconciliationComponentExportTabTitle: 'Comptes',
	reconciliationComponentExport: {
		status: 'État',
		primaryTeamAccountName: 'Primary Team account name',
		componentTeamAccountNames: 'Nom du ou des comptes de l’équipe affectée à l’audit de la composante',
		pspIndexes: 'Référence(s) PCB',
		designation: 'Désignation',
		c: 'Exh',
		eo: 'Exi/R',
		mv: 'M/Év',
		ro: 'D&O',
		pd: 'P&I',
		comment: 'Commentaire'
	},
	groupRiskStatusLabels : {
		[groupRiskStatus.open]: "Ouvert",
		[groupRiskStatus.assessed]: "Évalué",
		[groupRiskStatus.mapped]: "Mappé",
		[groupRiskStatus.unmapped]: "Non mappé",
		[groupRiskStatus.notApplicable]: "Non applicable",
		[groupRiskStatus.systemReOpened]: "Open"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: 'État',
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: 'Exh',
		eo: 'Exi/R',
		mv: 'M/Év',
		ro: 'D&O',
		pd: 'P&I',
		comment: 'Commentaire'
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: 'Significant account',
	[accountDesignations.limitedRiskAccount]: 'Limited risk account',
	[accountDesignations.insignificantAccount]: 'Négligeable',
	[accountDesignations.otherAccount]: 'Autre',
	[accountDesignations.significantDisclosure]: 'Information à fournir importante'
};

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
};
